import * as i0 from '@angular/core';
import { Injectable, Inject, isDevMode, inject, NgModule, Optional, SkipSelf } from '@angular/core';
import * as i2 from '@angular/common';
import { Location, CommonModule } from '@angular/common';
import * as i1 from '@angular/common/http';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CitadelStylesModule } from '@citadel/ds-styles';
import { BehaviorSubject, Subject, filter, ReplaySubject, of, mergeMap as mergeMap$1, tap as tap$1, catchError as catchError$1, map as map$1, distinctUntilChanged as distinctUntilChanged$1, from, take, iif, throwError, switchMap as switchMap$1, zip, combineLatest, EMPTY, NEVER, first as first$1 } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { distinctUntilChanged, mergeMap, map, tap, catchError, take as take$1, filter as filter$1, retryWhen, concatMap, delay, finalize, switchMap, distinctUntilKeyChanged, first, debounceTime, toArray } from 'rxjs/operators';
import * as i1$1 from '@angular/router';
import { ActivatedRouteSnapshot, NavigationStart, NavigationEnd, NavigationCancel, NavigationError, ResolveEnd, ActivationEnd, RouterModule } from '@angular/router';
import { Log as Log$1, UserManager, WebStorageStateStore } from 'oidc-client-ts';
import { pausedBy } from '@citadel/ds-pipes';
import * as i1$2 from 'ngx-device-detector';
import { fetchEventSource } from '@microsoft/fetch-event-source';
import { FormGroup } from '@angular/forms';
import * as i1$3 from '@angular/cdk/layout';
import { Breakpoints } from '@angular/cdk/layout';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

/** Returns a new date with number of days added */
Date.prototype.addDays = function (days) {
    const dateCopy = new Date(this);
    dateCopy.setDate(dateCopy.getDate() + days);
    return dateCopy;
};
/** Returns a new date with number of months added */
Date.prototype.addMonths = function (months) {
    const dateCopy = new Date(this);
    dateCopy.setMonth(dateCopy.getMonth() + months);
    return dateCopy;
};
/** Returns a new date with number of years added */
Date.prototype.addYears = function (years) {
    const dateCopy = new Date(this);
    dateCopy.setFullYear(dateCopy.getFullYear() + years);
    return dateCopy;
};
/** Returns a date string in the format yyyy-mm-dd, eg. 2023-12-31 */
Date.prototype.toYMD = function () {
    return this.getFullYear().toString() + '-' + (this.getMonth() + 1).toString().padStart(2, '0') + '-' + this.getDate().toString().padStart(2, '0');
};

const accentMap = {
    'ẚ': 'a', 'Á': 'a', 'á': 'a', 'À': 'a', 'à': 'a', 'Ă': 'a', 'ă': 'a', 'Ắ': 'a', 'ắ': 'a', 'Ằ': 'a', 'ằ': 'a', 'Ẵ': 'a', 'ẵ': 'a', 'Ẳ': 'a', 'ẳ': 'a', 'Â': 'a', 'â': 'a', 'Ấ': 'a', 'ấ': 'a', 'Ầ': 'a', 'ầ': 'a', 'Ẫ': 'a', 'ẫ': 'a', 'Ẩ': 'a', 'ẩ': 'a', 'Ǎ': 'a', 'ǎ': 'a', 'Å': 'a', 'å': 'a', 'Ǻ': 'a', 'ǻ': 'a', 'Ä': 'a', 'ä': 'a', 'Ǟ': 'a', 'ǟ': 'a', 'Ã': 'a', 'ã': 'a', 'Ȧ': 'a', 'ȧ': 'a', 'Ǡ': 'a', 'ǡ': 'a', 'Ą': 'a', 'ą': 'a', 'Ā': 'a', 'ā': 'a', 'Ả': 'a', 'ả': 'a', 'Ȁ': 'a', 'ȁ': 'a', 'Ȃ': 'a', 'ȃ': 'a', 'Ạ': 'a', 'ạ': 'a', 'Ặ': 'a', 'ặ': 'a', 'Ậ': 'a', 'ậ': 'a', 'Ḁ': 'a', 'ḁ': 'a', 'Ⱥ': 'a', 'ⱥ': 'a', 'Ǽ': 'a', 'ǽ': 'a', 'Ǣ': 'a', 'ǣ': 'a',
    'Ḃ': 'b', 'ḃ': 'b', 'Ḅ': 'b', 'ḅ': 'b', 'Ḇ': 'b', 'ḇ': 'b', 'Ƀ': 'b', 'ƀ': 'b', 'ᵬ': 'b', 'Ɓ': 'b', 'ɓ': 'b', 'Ƃ': 'b', 'ƃ': 'b',
    'Ć': 'c', 'ć': 'c', 'Ĉ': 'c', 'ĉ': 'c', 'Č': 'c', 'č': 'c', 'Ċ': 'c', 'ċ': 'c', 'Ç': 'c', 'ç': 'c', 'Ḉ': 'c', 'ḉ': 'c', 'Ȼ': 'c', 'ȼ': 'c', 'Ƈ': 'c', 'ƈ': 'c', 'ɕ': 'c',
    'Ď': 'd', 'ď': 'd', 'Ḋ': 'd', 'ḋ': 'd', 'Ḑ': 'd', 'ḑ': 'd', 'Ḍ': 'd', 'ḍ': 'd', 'Ḓ': 'd', 'ḓ': 'd', 'Ḏ': 'd', 'ḏ': 'd', 'Đ': 'd', 'đ': 'd', 'ᵭ': 'd', 'Ɖ': 'd', 'ɖ': 'd', 'Ɗ': 'd', 'ɗ': 'd', 'Ƌ': 'd', 'ƌ': 'd', 'ȡ': 'd', 'ð': 'd',
    'É': 'e', 'Ə': 'e', 'Ǝ': 'e', 'ǝ': 'e', 'é': 'e', 'È': 'e', 'è': 'e', 'Ĕ': 'e', 'ĕ': 'e', 'Ê': 'e', 'ê': 'e', 'Ế': 'e', 'ế': 'e', 'Ề': 'e', 'ề': 'e', 'Ễ': 'e', 'ễ': 'e', 'Ể': 'e', 'ể': 'e', 'Ě': 'e', 'ě': 'e', 'Ë': 'e', 'ë': 'e', 'Ẽ': 'e', 'ẽ': 'e', 'Ė': 'e', 'ė': 'e', 'Ȩ': 'e', 'ȩ': 'e', 'Ḝ': 'e', 'ḝ': 'e', 'Ę': 'e', 'ę': 'e', 'Ē': 'e', 'ē': 'e', 'Ḗ': 'e', 'ḗ': 'e', 'Ḕ': 'e', 'ḕ': 'e', 'Ẻ': 'e', 'ẻ': 'e', 'Ȅ': 'e', 'ȅ': 'e', 'Ȇ': 'e', 'ȇ': 'e', 'Ẹ': 'e', 'ẹ': 'e', 'Ệ': 'e', 'ệ': 'e', 'Ḙ': 'e', 'ḙ': 'e', 'Ḛ': 'e', 'ḛ': 'e', 'Ɇ': 'e', 'ɇ': 'e', 'ɚ': 'e', 'ɝ': 'e',
    'Ḟ': 'f', 'ḟ': 'f', 'ᵮ': 'f', 'Ƒ': 'f', 'ƒ': 'f',
    'Ǵ': 'g', 'ǵ': 'g', 'Ğ': 'g', 'ğ': 'g', 'Ĝ': 'g', 'ĝ': 'g', 'Ǧ': 'g', 'ǧ': 'g', 'Ġ': 'g', 'ġ': 'g', 'Ģ': 'g', 'ģ': 'g', 'Ḡ': 'g', 'ḡ': 'g', 'Ǥ': 'g', 'ǥ': 'g', 'Ɠ': 'g', 'ɠ': 'g',
    'Ĥ': 'h', 'ĥ': 'h', 'Ȟ': 'h', 'ȟ': 'h', 'Ḧ': 'h', 'ḧ': 'h', 'Ḣ': 'h', 'ḣ': 'h', 'Ḩ': 'h', 'ḩ': 'h', 'Ḥ': 'h', 'ḥ': 'h', 'Ḫ': 'h', 'ḫ': 'h', 'H': 'h', '̱': 'h', 'ẖ': 'h', 'Ħ': 'h', 'ħ': 'h', 'Ⱨ': 'h', 'ⱨ': 'h',
    'Í': 'i', 'í': 'i', 'Ì': 'i', 'ì': 'i', 'Ĭ': 'i', 'ĭ': 'i', 'Î': 'i', 'î': 'i', 'Ǐ': 'i', 'ǐ': 'i', 'Ï': 'i', 'ï': 'i', 'Ḯ': 'i', 'ḯ': 'i', 'Ĩ': 'i', 'ĩ': 'i', 'İ': 'i', 'i': 'i', 'Į': 'i', 'į': 'i', 'Ī': 'i', 'ī': 'i', 'Ỉ': 'i', 'ỉ': 'i', 'Ȉ': 'i', 'ȉ': 'i', 'Ȋ': 'i', 'ȋ': 'i', 'Ị': 'i', 'ị': 'i', 'Ḭ': 'i', 'ḭ': 'i', 'I': 'i', 'ı': 'i', 'Ɨ': 'i', 'ɨ': 'i',
    'Ĵ': 'j', 'ĵ': 'j', 'J': 'j', '̌': 'j', 'ǰ': 'j', 'ȷ': 'j', 'Ɉ': 'j', 'ɉ': 'j', 'ʝ': 'j', 'ɟ': 'j', 'ʄ': 'j',
    'Ḱ': 'k', 'ḱ': 'k', 'Ǩ': 'k', 'ǩ': 'k', 'Ķ': 'k', 'ķ': 'k', 'Ḳ': 'k', 'ḳ': 'k', 'Ḵ': 'k', 'ḵ': 'k', 'Ƙ': 'k', 'ƙ': 'k', 'Ⱪ': 'k', 'ⱪ': 'k',
    'Ĺ': 'l', 'ĺ': 'l', 'Ľ': 'l', 'ľ': 'l', 'Ļ': 'l', 'ļ': 'l', 'Ḷ': 'l', 'ḷ': 'l', 'Ḹ': 'l', 'ḹ': 'l', 'Ḽ': 'l', 'ḽ': 'l', 'Ḻ': 'l', 'ḻ': 'l', 'Ł': 'l', 'Ŀ': 'l', 'ŀ': 'l', 'Ƚ': 'l', 'ƚ': 'l', 'Ⱡ': 'l', 'ⱡ': 'l', 'Ɫ': 'l', 'ɫ': 'l', 'ɬ': 'l', 'ɭ': 'l', 'ȴ': 'l',
    'Ḿ': 'm', 'ḿ': 'm', 'Ṁ': 'm', 'ṁ': 'm', 'Ṃ': 'm', 'ṃ': 'm', 'ɱ': 'm',
    'Ń': 'n', 'ń': 'n', 'Ǹ': 'n', 'ǹ': 'n', 'Ň': 'n', 'ň': 'n', 'Ñ': 'n', 'ñ': 'n', 'Ṅ': 'n', 'ṅ': 'n', 'Ņ': 'n', 'ņ': 'n', 'Ṇ': 'n', 'ṇ': 'n', 'Ṋ': 'n', 'ṋ': 'n', 'Ṉ': 'n', 'ṉ': 'n', 'Ɲ': 'n', 'ɲ': 'n', 'Ƞ': 'n', 'ƞ': 'n', 'ɳ': 'n', 'ȵ': 'n', 'N': 'n', '̈': 'n', 'n': 'n',
    'Ó': 'o', 'ó': 'o', 'Ò': 'o', 'ò': 'o', 'Ŏ': 'o', 'ŏ': 'o', 'Ô': 'o', 'ô': 'o', 'Ố': 'o', 'ố': 'o', 'Ồ': 'o', 'ồ': 'o', 'Ỗ': 'o', 'ỗ': 'o', 'Ổ': 'o', 'ổ': 'o', 'Ǒ': 'o', 'ǒ': 'o', 'Ö': 'o', 'ö': 'o', 'Ȫ': 'o', 'ȫ': 'o', 'Ő': 'o', 'ő': 'o', 'Õ': 'o', 'õ': 'o', 'Ṍ': 'o', 'ṍ': 'o', 'Ṏ': 'o', 'ṏ': 'o', 'Ȭ': 'o', 'ȭ': 'o', 'Ȯ': 'o', 'ȯ': 'o', 'Ȱ': 'o', 'ȱ': 'o', 'Ø': 'o', 'ø': 'o', 'Ǿ': 'o', 'ǿ': 'o', 'Ǫ': 'o', 'ǫ': 'o', 'Ǭ': 'o', 'ǭ': 'o', 'Ō': 'o', 'ō': 'o', 'Ṓ': 'o', 'ṓ': 'o', 'Ṑ': 'o', 'ṑ': 'o', 'Ỏ': 'o', 'ỏ': 'o', 'Ȍ': 'o', 'ȍ': 'o', 'Ȏ': 'o', 'ȏ': 'o', 'Ơ': 'o', 'ơ': 'o', 'Ớ': 'o', 'ớ': 'o', 'Ờ': 'o', 'ờ': 'o', 'Ỡ': 'o', 'ỡ': 'o', 'Ở': 'o', 'ở': 'o', 'Ợ': 'o', 'ợ': 'o', 'Ọ': 'o', 'ọ': 'o', 'Ộ': 'o', 'ộ': 'o', 'Ɵ': 'o', 'ɵ': 'o',
    'Ṕ': 'p', 'ṕ': 'p', 'Ṗ': 'p', 'ṗ': 'p', 'Ᵽ': 'p', 'Ƥ': 'p', 'ƥ': 'p', 'P': 'p', '̃': 'p', 'p': 'p',
    'ʠ': 'q', 'Ɋ': 'q', 'ɋ': 'q',
    'Ŕ': 'r', 'ŕ': 'r', 'Ř': 'r', 'ř': 'r', 'Ṙ': 'r', 'ṙ': 'r', 'Ŗ': 'r', 'ŗ': 'r', 'Ȑ': 'r', 'ȑ': 'r', 'Ȓ': 'r', 'ȓ': 'r', 'Ṛ': 'r', 'ṛ': 'r', 'Ṝ': 'r', 'ṝ': 'r', 'Ṟ': 'r', 'ṟ': 'r', 'Ɍ': 'r', 'ɍ': 'r', 'ᵲ': 'r', 'ɼ': 'r', 'Ɽ': 'r', 'ɽ': 'r', 'ɾ': 'r', 'ᵳ': 'r',
    'ß': 's', 'Ś': 's', 'ś': 's', 'Ṥ': 's', 'ṥ': 's', 'Ŝ': 's', 'ŝ': 's', 'Š': 's', 'š': 's', 'Ṧ': 's', 'ṧ': 's', 'Ṡ': 's', 'ṡ': 's', 'ẛ': 's', 'Ş': 's', 'ş': 's', 'Ṣ': 's', 'ṣ': 's', 'Ṩ': 's', 'ṩ': 's', 'Ș': 's', 'ș': 's', 'ʂ': 's', 'S': 's', '̩': 's', 's': 's',
    'Þ': 't', 'þ': 't', 'Ť': 't', 'ť': 't', 'T': 't', 'ẗ': 't', 'Ṫ': 't', 'ṫ': 't', 'Ţ': 't', 'ţ': 't', 'Ṭ': 't', 'ṭ': 't', 'Ț': 't', 'ț': 't', 'Ṱ': 't', 'ṱ': 't', 'Ṯ': 't', 'ṯ': 't', 'Ŧ': 't', 'ŧ': 't', 'Ⱦ': 't', 'ⱦ': 't', 'ᵵ': 't', 'ƫ': 't', 'Ƭ': 't', 'ƭ': 't', 'Ʈ': 't', 'ʈ': 't', 'ȶ': 't',
    'Ú': 'u', 'ú': 'u', 'Ù': 'u', 'ù': 'u', 'Ŭ': 'u', 'ŭ': 'u', 'Û': 'u', 'û': 'u', 'Ǔ': 'u', 'ǔ': 'u', 'Ů': 'u', 'ů': 'u', 'Ü': 'u', 'ü': 'u', 'Ǘ': 'u', 'ǘ': 'u', 'Ǜ': 'u', 'ǜ': 'u', 'Ǚ': 'u', 'ǚ': 'u', 'Ǖ': 'u', 'ǖ': 'u', 'Ű': 'u', 'ű': 'u', 'Ũ': 'u', 'ũ': 'u', 'Ṹ': 'u', 'ṹ': 'u', 'Ų': 'u', 'ų': 'u', 'Ū': 'u', 'ū': 'u', 'Ṻ': 'u', 'ṻ': 'u', 'Ủ': 'u', 'ủ': 'u', 'Ȕ': 'u', 'ȕ': 'u', 'Ȗ': 'u', 'ȗ': 'u', 'Ư': 'u', 'ư': 'u', 'Ứ': 'u', 'ứ': 'u', 'Ừ': 'u', 'ừ': 'u', 'Ữ': 'u', 'ữ': 'u', 'Ử': 'u', 'ử': 'u', 'Ự': 'u', 'ự': 'u', 'Ụ': 'u', 'ụ': 'u', 'Ṳ': 'u', 'ṳ': 'u', 'Ṷ': 'u', 'ṷ': 'u', 'Ṵ': 'u', 'ṵ': 'u', 'Ʉ': 'u', 'ʉ': 'u',
    'Ṽ': 'v', 'ṽ': 'v', 'Ṿ': 'v', 'ṿ': 'v', 'Ʋ': 'v', 'ʋ': 'v',
    'Ẃ': 'w', 'ẃ': 'w', 'Ẁ': 'w', 'ẁ': 'w', 'Ŵ': 'w', 'ŵ': 'w', 'W': 'w', '̊': 'w', 'ẘ': 'w', 'Ẅ': 'w', 'ẅ': 'w', 'Ẇ': 'w', 'ẇ': 'w', 'Ẉ': 'w', 'ẉ': 'w',
    'Ẍ': 'x', 'ẍ': 'x', 'Ẋ': 'x', 'ẋ': 'x',
    'Ý': 'y', 'ý': 'y', 'Ỳ': 'y', 'ỳ': 'y', 'Ŷ': 'y', 'ŷ': 'y', 'Y': 'y', 'ẙ': 'y', 'Ÿ': 'y', 'ÿ': 'y', 'Ỹ': 'y', 'ỹ': 'y', 'Ẏ': 'y', 'ẏ': 'y', 'Ȳ': 'y', 'ȳ': 'y', 'Ỷ': 'y', 'ỷ': 'y', 'Ỵ': 'y', 'ỵ': 'y', 'ʏ': 'y', 'Ɏ': 'y', 'ɏ': 'y', 'Ƴ': 'y', 'ƴ': 'y',
    'Ź': 'z', 'ź': 'z', 'Ẑ': 'z', 'ẑ': 'z', 'Ž': 'z', 'ž': 'z', 'Ż': 'z', 'ż': 'z', 'Ẓ': 'z', 'ẓ': 'z', 'Ẕ': 'z', 'ẕ': 'z', 'Ƶ': 'z', 'ƶ': 'z', 'Ȥ': 'z', 'ȥ': 'z', 'ʐ': 'z', 'ʑ': 'z', 'Ⱬ': 'z', 'ⱬ': 'z', 'Ǯ': 'z', 'ǯ': 'z', 'ƺ': 'z'
};
class CitadelTextService {
    newGuid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
    replaceAccents(s) {
        if (!s) {
            return '';
        }
        let ret = '';
        for (let i = 0; i < s.length; i++) {
            ret += accentMap[s.charAt(i)] || s.charAt(i);
        }
        return ret;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelTextService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelTextService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelTextService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

class SafeToastrService extends ToastrService {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SafeToastrService, deps: null, target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SafeToastrService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SafeToastrService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

class CitadelNotificationService {
    constructor(toastr) {
        this.toastr = toastr;
        this.fullWidth = new BehaviorSubject(false);
        this.subject = new Subject();
        this.observable = this.subject.asObservable()
            .pipe(filter(value => !this.toastr.findDuplicate(value.title, value.message, false, false)));
        this.defaultProps = { progressBar: true, positionClass: 'toast-top-center', timeOut: 5000, tapToDismiss: true };
        this.observable.subscribe(value => {
            if (value.type === 'danger') {
                this.toastr.error(value.message, value.title, { ...this.defaultProps, toastClass: `toast-error` });
            }
            else if (value.type === 'info') {
                this.toastr.info(value.message, value.title, { ...this.defaultProps, toastClass: `toast-info` });
            }
            else if (value.type === 'warning') {
                this.toastr.warning(value.message, value.title, { ...this.defaultProps, toastClass: `toast-warning` });
            }
            else if (value.type === 'success') {
                this.toastr.success(value.message, value.title, { ...this.defaultProps, toastClass: `toast-success` });
            }
        });
    }
    info(message, title) {
        // tslint:disable-next-line: no-console
        console.info('NotificationService', message);
        this.subject.next({ message: message, title: title, type: 'info' });
    }
    error(message, title) {
        console.error('NotificationService', message);
        this.subject.next({ message: message, title: title, type: 'danger' });
    }
    warning(message, title) {
        console.warn('NotificationService', message);
        this.subject.next({ message: message, title: title, type: 'warning' });
    }
    success(message, title) {
        // tslint:disable-next-line: no-console
        console.info('NotificationService', message);
        this.subject.next({ message: message, title: title, type: 'success' });
    }
    isFullWidth() {
        return this.fullWidth.asObservable();
    }
    setFullWidth(isFullWidth) {
        this.fullWidth.next(isFullWidth);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelNotificationService, deps: [{ token: SafeToastrService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelNotificationService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelNotificationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: SafeToastrService }] });

class CitadelStorageService {
    getPrefix(username) {
        return username ? username + '///' : '';
    }
    finalKey(key, username) {
        return this.getPrefix(username) + key;
    }
    read(key, username) {
        const data = localStorage.getItem(this.finalKey(key, username));
        if (key.endsWith('storageSilentRenewRunning') && !data) {
            return null;
        }
        else if (data !== null) {
            return JSON.parse(data);
        }
        return;
    }
    write(key, value, username) {
        localStorage.setItem(this.finalKey(key, username), JSON.stringify(value));
    }
    exists(key, username) {
        return !!(localStorage.getItem(this.finalKey(key, username)));
    }
    remove(key, username) {
        localStorage.removeItem(this.finalKey(key, username));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelStorageService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelStorageService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelStorageService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

class CustomEncoder {
    encodeKey(key) {
        return encodeURIComponent(key);
    }
    encodeValue(value) {
        return encodeURIComponent(value);
    }
    decodeKey(key) {
        return decodeURIComponent(key);
    }
    decodeValue(value) {
        return decodeURIComponent(value);
    }
}

const CITADEL_DIAGNOSTIC_OPTIONS = 'diagnosticOptions';

class CitadelDiagnosticsService {
    get isProduction() {
        return !!(this.options && this.options.isProduction);
    }
    get authDisableSilentRenew() {
        return !!(this.options && this.options.authDisableSilentRenew);
    }
    get loggingOptions() {
        return this.logging;
    }
    constructor(options) {
        this.options = options;
        this.logging = {};
        this.noResetUrls = [];
        this.logging = {
            authentication: !!(options && options.loggingOptions && options.loggingOptions.authentication),
            silentRenew: !!(options && options.loggingOptions && options.loggingOptions.silentRenew),
            routing: !!(options && options.loggingOptions && options.loggingOptions.routing),
            http: !!(options && options.loggingOptions && options.loggingOptions.http),
        };
        this.noResetUrls = options.noResetUrls || [];
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelDiagnosticsService, deps: [{ token: CITADEL_DIAGNOSTIC_OPTIONS }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelDiagnosticsService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelDiagnosticsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [CITADEL_DIAGNOSTIC_OPTIONS]
                }] }] });

class Queue {
    constructor(capacity = 1000) {
        this.capacity = capacity;
        this.values = [];
        this.head = 0;
    }
    enqueue(value) {
        if (this.head === this.capacity) {
            this.head = 0;
        }
        this.values[this.head] = value;
        this.head++;
    }
    getQueue() {
        const text = [];
        for (let i = this.head - 1; i >= 0; i--) {
            text.push(this.values[i].toString());
        }
        if (this.values.length === this.capacity) {
            for (let i = this.values.length - 1; i > this.head - 1; i--) {
                text.push(this.values[i].toString());
            }
        }
        return text;
    }
    toString() {
        const text = this.getQueue();
        // console.log({ head: this.head, values: this.values });
        return (this.head.toString() +
            ' [' +
            text.reduce((prev, current) => {
                if (!!prev) {
                    return `${prev}, ${current}`;
                }
                else {
                    return current;
                }
            }) +
            ']');
    }
}
class CachedAuthLoggerService {
    constructor(diagnostics) {
        this.diagnostics = diagnostics;
        this.queue = new Queue();
        // window['decant'] = this;
        // this.attachBeforeUnload();
    }
    error(...args) {
        this.queue.enqueue(`[error] ${args}`);
        // if (this.hasMessage(args, 'No matching state found in storage')) {
        //   this.decant('StorageError');
        // }
        console.error(...args);
    }
    warn(...args) {
        this.queue.enqueue(`[warn] ${args}`);
        console.warn(...args);
    }
    debug(...args) {
        const isSilentRenewMessage = (this.hasMessage(args, 'SilentRenew') ||
            this.hasMessage(args, 'Timer(\'Access token expiring\')') ||
            this.hasMessage(args, 'Timer(\'Access token expired\')') ||
            this.hasMessage(args, 'CheckSessionIFrame'));
        const mustLog = this.diagnostics.loggingOptions?.silentRenew || !isSilentRenewMessage;
        const prefix = (this.diagnostics.loggingOptions?.silentRenew && isSilentRenewMessage) ? '[silentRenew] ' : '';
        if (mustLog) {
            this.queue.enqueue(`[debug] ${prefix}${args}`);
            console.log(...args);
        }
    }
    log(...args) {
        this.queue.enqueue(`[log] ${args}`);
        // if (this.hasMessage(args, 'SESSION STATUS')) {
        //   this.decant('SignedIn');
        // }
        console.log(...args);
    }
    info(...args) {
        this.queue.enqueue(`[info] ${args}`);
        console.info(...args);
    }
    // decant(name: string) {
    //   localStorage.setItem(`decant-${name}`, JSON.stringify(this.queue.getQueue()))
    // }
    // private attachBeforeUnload() {
    //   window.addEventListener("beforeunload", e => {
    //     this.decant('Navigating');
    //   });
    // }
    hasMessage(args, message) {
        return args.some(v => !!v && v.toString().includes(message));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CachedAuthLoggerService, deps: [{ token: CitadelDiagnosticsService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CachedAuthLoggerService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CachedAuthLoggerService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: CitadelDiagnosticsService }] });

class Configuration {
    constructor(wrappedObject) {
        this.wrappedObject = wrappedObject;
    }
    get(configPath) {
        const segments = configPath.split(':');
        let result = this.wrappedObject;
        for (const segment of segments) {
            result = result[segment];
            if (result === undefined) {
                break;
            }
        }
        return result;
    }
}

class CitadelConfigurationService {
    constructor(httpBackend, location) {
        this.httpBackend = httpBackend;
        this.location = location;
        this.fields = {
            mainAppName: '',
            appSettings: {
                configPath: '',
                environment: '',
            },
            config: {},
            subjects: {
                appSettingsLoaded: new ReplaySubject(1),
                allowedFileTypes: new ReplaySubject(1),
                allowedMimeTypes: new ReplaySubject(1),
                notificationPollingInterval: new ReplaySubject(1),
            },
            observables: {
                appSettingsLoaded: undefined,
                allowedFileTypes: undefined,
                allowedMimeTypes: undefined,
                notificationPollingInterval: undefined,
            },
        };
        // console.info('Created config service');
        this.fields.observables.appSettingsLoaded = this.fields.subjects.appSettingsLoaded.asObservable();
        this.fields.observables.allowedFileTypes = this.fields.subjects.allowedFileTypes.asObservable();
        this.fields.observables.allowedMimeTypes = this.fields.subjects.allowedMimeTypes.asObservable();
        this.fields.observables.notificationPollingInterval = this.fields.subjects.notificationPollingInterval.asObservable().pipe(distinctUntilChanged());
        this.http = new HttpClient(this.httpBackend);
        this.loadApplicationConfig(this.http);
    }
    getGlobalSettingsLoaded() {
        return this.fields.observables.appSettingsLoaded;
    }
    getConfig(serviceName) {
        serviceName = this.handleDefaultConfig(serviceName);
        if (!this.fields.observables[serviceName]) {
            const subject = new ReplaySubject(1);
            this.fields.subjects[serviceName] = subject;
            this.fields.observables[serviceName] = subject.asObservable();
            this.fields.observables.appSettingsLoaded
                .pipe(mergeMap((appSettings) => {
                if (!serviceName) {
                    serviceName = appSettings.application;
                    this.fields.mainAppName = appSettings.application;
                }
                const queryString = appSettings.versionTag ? `?versionTag=${appSettings.versionTag}` : '';
                return this.http.get(Location.joinWithSlash(appSettings.configPath, `Application/config/${serviceName}/${appSettings.environment}${queryString}`));
            }))
                .pipe(map(result => {
                const config = new Configuration(result);
                this.fields.config[serviceName] = config;
                return config;
            }))
                .pipe(tap(result => this.loadWhitelistedFileTypes(result)))
                .pipe(tap(result => this.loadNotificationPollingInterval(result)))
                .subscribe(result => {
                subject.next(result);
            });
        }
        return this.fields.observables[serviceName];
    }
    getAllowedFileTypes() {
        return this.fields.observables.allowedFileTypes;
    }
    getNotificationPollingInterval() {
        return this.fields.observables.notificationPollingInterval;
    }
    getAllowedMimeTypes() {
        return this.fields.observables.allowedMimeTypes;
    }
    loadWhitelistedFileTypes(config) {
        const globalConfig = config.wrappedObject ? config.wrappedObject.Global : undefined;
        const types = globalConfig ? globalConfig.FileTypeWhitelist : {} || {};
        const exts = [];
        const mimeTypes = [];
        for (const prop in types) {
            if (types.hasOwnProperty(prop)) {
                exts.push(prop.toLowerCase());
                const mimeType = types[prop] || 'text/plain';
                mimeTypes.push({ ext: prop.toLowerCase(), mimeType: mimeType.toLowerCase() });
            }
        }
        this.fields.subjects.allowedFileTypes.next([...new Set(exts)]);
        this.fields.subjects.allowedMimeTypes.next([...new Set(mimeTypes)]);
    }
    loadNotificationPollingInterval(config) {
        const globalConfig = config.wrappedObject ? config.wrappedObject.Global : undefined;
        const interval = globalConfig ? globalConfig.NotificationPollingInterval : globalConfig.NotificationPollingInterval || 900000;
        this.fields.subjects.notificationPollingInterval.next(interval);
    }
    loadApplicationConfig(http) {
        const appSettingsUrl = `/assets/appsettings.json`;
        http.get(this.location.prepareExternalUrl(appSettingsUrl)).pipe(map((content) => {
            const settings = {
                ignoreConfig: content['IgnoreConfig'],
                applicationID: content['ApplicationID'],
                application: content['ApplicationName'],
                environment: content['Environment'],
                versionTag: content['VersionTag'] || 'Default',
                rerouteAddress: content['RerouteAddress'],
                appPrefix: content['AppPrefix'],
                configPath: content['Services'] ? content['Services']['Citadel.Framework.Config'] : '',
                services: content['Services'] ? content['Services'] : {},
            };
            return settings;
        }), catchError((error) => {
            console.error('appsettings.json could not be loaded', error);
            return of(null);
        })).subscribe((settings) => {
            if (!settings) {
                return;
            }
            if (settings.ignoreConfig) {
                this.fields.appSettings = settings;
                this.fields.subjects.appSettingsLoaded.next(settings);
                return;
            }
            this.loadApplicationScopes(settings);
        });
    }
    loadApplicationScopes(settings) {
        this.http.get(Location.joinWithSlash(settings.configPath, `Application/scopes/${settings.application}/${settings.environment}/${settings.versionTag}`))
            .pipe(map((value) => {
            const result = {};
            for (const entry of value) {
                result[entry.label] = entry.value;
            }
            return result;
        }))
            .subscribe((value) => {
            settings.authSettings = value;
            this.fields.appSettings = settings;
            this.fields.subjects.appSettingsLoaded.next(settings);
            if (!this.fields.appSettings.configPath || !this.fields.appSettings.environment) {
                throw new Error('Valid configuration file not found.');
            }
        });
    }
    handleDefaultConfig(serviceName) {
        if (!serviceName && this.fields.mainAppName) {
            if (this.fields.subjects[serviceName] && !this.fields.subjects[this.fields.mainAppName]) {
                this.fields.subjects[this.fields.mainAppName] = this.fields.subjects[serviceName];
            }
            serviceName = this.fields.mainAppName;
        }
        return serviceName;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelConfigurationService, deps: [{ token: i1.HttpBackend }, { token: i2.Location }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelConfigurationService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelConfigurationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: i1.HttpBackend }, { type: i2.Location }] });

// error-logging.service.ts
class CitadelErrorLoggingService {
    constructor(httpBackend, config) {
        this.httpBackend = httpBackend;
        this.config = config;
        this.errors = new ReplaySubject(100);
        this.originalConsoleError = console.error;
        this.originalConsoleWarn = console.warn;
        this.callCount = 0;
        this.lastCallTime = 0;
        this.rateLimitMessageEmitted = false;
        this.RATE_LIMIT = 5; // Maximum number of calls
        this.TIME_WINDOW = 1000; // Time window in milliseconds
        this.SEND_INTERVAL = 300000; // 5 minutes in milliseconds
        this.messageBuffer = [];
        this.rateLimiterMessage = this.getErrorInformation('rate limiter', 'Rate limiting implemented due to too many messages');
        this.overrideConsoleError();
        this.overrideConsoleWarn();
        // window.console = console;
        this.setupPeriodicSend();
        this.setupBeforeUnloadSend();
        // this.getLoggingUrl(config);
    }
    logError(errorOrSource, message) {
        if (this.isRateLimited()) {
            if (!this.rateLimitMessageEmitted) {
                const rateLimitMessage = this.rateLimiterMessage;
                this.rateLimitMessageEmitted = true;
                if (this.messageBuffer.length > 0 && this.messageBuffer[this.messageBuffer.length - 1] !== this.rateLimiterMessage) {
                    this.messageBuffer.push(rateLimitMessage);
                    this.errors.next(rateLimitMessage);
                }
            }
            return;
        }
        const errorInfo = this.getErrorInformation(errorOrSource, message);
        this.errors.next(errorInfo);
        this.messageBuffer.push(errorInfo);
    }
    getErrors() {
        return this.errors.asObservable();
    }
    sendMessagesToWebService() {
        this.setupPeriodicSend();
        if (this.hasMessagesToLog()) {
            const body = this.messageBuffer.map(message => ({
                message: message.message,
                source: message.source,
                stackTrace: message.stack.join('\n'),
                loggedAt: message.loggedAt,
            }));
            // return this.web.post('Citadel.UiLogging', body, { headers: headers })
            let headers = new HttpHeaders({
                'content-type': 'application/json',
            });
            if (this.currentToken) {
                headers = headers.set('Authorization', `Bearer ${this.currentToken}`);
            }
            const http = new HttpClient(this.httpBackend);
            return this.getLoggingUrl(this.config).pipe(mergeMap$1(loggingUrl => http.post(Location.joinWithSlash(loggingUrl, 'ui'), {
                clientTime: new Date(),
                sourceUrl: window.location.href,
                entries: body,
            }, {
                headers: headers,
            }).pipe(tap$1(() => this.messageBuffer = []), catchError$1(() => of({})))));
        }
        return of({});
    }
    setCurrentToken(token) {
        this.currentToken = token;
    }
    hasMessagesToLog() {
        return this.messageBuffer
            .filter(message => message.source !== 'auth.warn')
            .filter(message => message.source !== 'console.warn')
            .filter(message => message.source !== 'navigation')
            .filter(message => message.source !== 'rate limiter')
            .length > 0;
    }
    getLoggingUrl(configService) {
        return configService.getConfig().pipe(map$1(config => config.get('Services:Citadel.Framework.Logging.API')));
    }
    overrideConsoleError() {
        console.error = (...args) => {
            // Call the original console.error method
            this.originalConsoleError.apply(console, args);
            if (args?.length >= 2 && args[0] === 'ERROR:' && (args[1] instanceof Error || args[1]?.name)) {
                return;
            }
            // Log the error using the error logging service
            this.logError('console.error', args.join(' '));
        };
    }
    overrideConsoleWarn() {
        console.warn = (...args) => {
            // Call the original console.error method
            this.originalConsoleWarn.apply(console, args);
            // Log the error using the error logging service
            this.logError('console.warn', args.join(' '));
        };
    }
    getErrorInformation(errorOrSource, message) {
        let result;
        if (typeof errorOrSource === 'string') {
            result = {
                loggedAt: new Date(),
                message: message || '<< no message supplied >>',
                stack: [],
                source: errorOrSource,
            };
        }
        else if (errorOrSource instanceof Error) {
            result = {
                loggedAt: new Date(),
                message: errorOrSource.message,
                stack: (errorOrSource.stack?.split('\n') || []).filter(line => line.trim().length > 0),
                source: errorOrSource.name,
            };
        }
        else if (errorOrSource.error instanceof Error) {
            result = {
                loggedAt: new Date(),
                message: errorOrSource.error.message,
                stack: (errorOrSource?.error?.stack?.split('\n') || []).filter(line => line.trim().length > 0),
                source: errorOrSource.source,
            };
        }
        else {
            const errorObj = errorOrSource;
            result = {
                loggedAt: new Date(),
                message: errorObj.message,
                stack: (errorObj.stack?.split('\n') || []).filter(line => line.trim().length > 0),
                source: errorObj.name,
            };
        }
        return result;
    }
    isRateLimited() {
        const now = Date.now();
        if (now - this.lastCallTime > this.TIME_WINDOW) {
            this.callCount = 0;
            this.lastCallTime = now;
            this.rateLimitMessageEmitted = false;
        }
        this.callCount++;
        return this.callCount > this.RATE_LIMIT;
    }
    setupPeriodicSend() {
        if (this.timerHandle) {
            clearTimeout(this.timerHandle);
        }
        this.timerHandle = setTimeout(() => {
            this.sendMessagesToWebService().subscribe(() => console.log('Logging checkpoint'));
        }, this.SEND_INTERVAL);
    }
    setupBeforeUnloadSend() {
        window.addEventListener('beforeunload', () => {
            //return this.sendMessagesToWebService();
            return 'Sending messages to web service';
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelErrorLoggingService, deps: [{ token: i1.HttpBackend }, { token: CitadelConfigurationService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelErrorLoggingService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelErrorLoggingService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1.HttpBackend }, { type: CitadelConfigurationService }] });

class AuthLibProxyService {
    constructor(diagnostic, router, cachedLogger, errorLogging) {
        this.diagnostic = diagnostic;
        this.router = router;
        this.cachedLogger = cachedLogger;
        this.errorLogging = errorLogging;
        this.fields = {
            subjects: {
                manager: new ReplaySubject(1),
                user: new ReplaySubject(1),
                authenticationStatus: new ReplaySubject(1),
                idToken: new ReplaySubject(1),
                accessToken: new ReplaySubject(1),
            },
            observables: {
                manager: undefined,
                user: undefined,
                authenticationStatus: undefined,
                idToken: undefined,
                accessToken: undefined,
            },
            auth: {
                manager: undefined,
                isSilentRenewStarted: false,
            },
            oldReadSigninResponseState: undefined,
        };
        Log$1.setLevel(Log$1.WARN);
        // Log.setLogger(cachedLogger);
        this.createObservables();
    }
    createObservables() {
        this.log('AUTH', 'createObservables');
        this.fields.observables.manager = this.fields.subjects.manager.asObservable();
        this.fields.observables.user = this.fields.subjects.user.asObservable().pipe(tap$1(user => this.log('User passed to auth service', user)), tap$1(user => this.log('Token obtained:', user?.access_token)), filter(user => {
            const isAssigned = !!user && !!user.profile;
            const isExpired = isAssigned && !this.isUserAuthenticated(user);
            return isAssigned && !isExpired;
        }), tap$1(user => {
            this.fields.subjects.idToken.next(user.id_token);
            this.fields.subjects.accessToken.next(user.access_token);
            this.errorLogging.setCurrentToken(user.access_token);
        }), map$1(user => user.profile), tap$1(user => this.log('User created', user['s_hash'])), tap$1(user => this.fields.subjects.authenticationStatus.next(this.isUserAuthenticated(user) ? 'authenticated' : 'unauthenticated')), distinctUntilChanged$1((previous, current) => {
            const result = !!previous && !!current &&
                (previous['http://schemas.citadel.co.za/scopes/claims/userinfo'] || previous['citadel-userinfo']) === (current['http://schemas.citadel.co.za/scopes/claims/userinfo'] || current['citadel-userinfo']);
            this.log('User distinct check', { previous, current, result });
            return result;
        }), catchError$1(error => {
            this.errorLogging.logError({ source: 'auth.error[1]', error: error });
            throw error;
        }));
        this.fields.observables.authenticationStatus = this.fields.subjects.authenticationStatus.asObservable().pipe(distinctUntilChanged$1(), tap$1(status => this.log('Auth status changed', status)));
        this.fields.observables.idToken = this.fields.subjects.idToken;
        this.fields.observables.accessToken = this.fields.subjects.accessToken;
    }
    isUserAuthenticated(user) {
        return !!user && this.dateAfterNow(user.exp || user.expires_at);
    }
    setConfig(config$) {
        config$.subscribe(config => {
            this.log('Config received');
            this.fields.auth.manager = new UserManager({
                authority: config.authority,
                client_id: config.clientID,
                redirect_uri: config.redirectUri,
                post_logout_redirect_uri: config.redirectUri,
                response_type: 'code',
                scope: `openid profile offline_access ${config.scope}`,
                filterProtocolClaims: true,
                loadUserInfo: true,
                prompt: 'login',
                automaticSilentRenew: true,
                // includeIdTokenInSilentRenew: true,
                clockSkewInSeconds: 1800,
                // monitorSession: true, // Breaks impersonation
                revokeTokensOnSignout: true,
                validateSubOnSilentRenew: false,
                userStore: new WebStorageStateStore({ store: localStorage }),
            });
            this.addAuthEvents(this.fields.auth.manager);
            this.fields.subjects.manager.next(this.fields.auth.manager);
            this.callGetUser();
        });
    }
    callGetUser() {
        this.log('callGetUser', 'Start');
        from(this.fields.auth.manager.getUser()).pipe(catchError$1(error => {
            this.errorLogging.logError({ source: 'auth.error[2]', error: error });
            throw error;
        })).subscribe(user => {
            this.log('callGetUser', 'Emit authentication status');
            this.fields.subjects.authenticationStatus.next(this.isUserAuthenticated(user) ? 'authenticated' : 'unauthenticated');
            this.log('callGetUser', 'Emit user');
            this.fields.subjects.user.next(user);
        });
    }
    newReadSigninResponseState(thisptr, client) {
        // eslint-disable-next-line @typescript-eslint/ban-types, no-restricted-syntax
        return async function (url, removeState = false) {
            // eslint-disable-next-line no-restricted-syntax
            return await thisptr.fields.oldReadSigninResponseState.call(client, url, removeState);
        };
    }
    addAuthEvents(manager) {
        if (!this.fields.oldReadSigninResponseState) {
            const client = manager['_client'];
            this.fields.oldReadSigninResponseState = client.readSigninResponseState;
            client.readSigninResponseState = this.newReadSigninResponseState(this, client);
        }
        this.addAuthEventsTokenExpired(manager);
        this.addAuthEventsSilentRenewError(manager);
        this.addAuthEventsUser(manager);
    }
    addAuthEventsSilentRenewError(manager) {
        manager.events.addSilentRenewError(err => {
            this.error('Silent renew error', err);
            this.signOut().pipe(catchError$1(error => {
                this.errorLogging.logError({ source: 'auth.error[3]', error: error });
                return this.errorLogging.sendMessagesToWebService();
            })).subscribe({
                next: () => from(this.router.navigateByUrl('/unauthorized?so')),
                error: (error) => {
                    this.error(error);
                    if (error instanceof Error) {
                        this.errorLogging.logError({ source: 'auth.error[4]', error: error });
                    }
                    else {
                        this.errorLogging.logError('auth.error[5]', JSON.stringify(error));
                    }
                }
            });
        });
    }
    addAuthEventsTokenExpired(manager) {
        manager.events.addAccessTokenExpired(() => {
            this.log('addAccessTokenExpired', 'Start');
            from(manager.removeUser()).pipe(tap$1(() => this.log('addAccessTokenExpired', 'removeUser() completed')), mergeMap$1(() => manager.revokeTokens()), mergeMap$1(() => {
                this.log('addAccessTokenExpired', 'Navigating to /unauthorized');
                this.errorLogging.logError('auth.error[6]', 'addAccessTokenExpired navigating to /unauthorized');
                return this.errorLogging.sendMessagesToWebService();
            }), tap$1(() => this.log('addAccessTokenExpired', 'revokeTokens() completed')), catchError$1(error => {
                this.errorLogging.logError({ source: 'auth.error[7]', error: error });
                throw this.errorLogging.sendMessagesToWebService();
            })).subscribe(() => {
                this.router.navigateByUrl('/unauthorized');
            });
        });
    }
    addAuthEventsUser(manager) {
        manager.events.addUserSignedIn(() => {
            /* Do nothing */
            this.log('User signed in');
            this.errorLogging.logError('auth.warn', 'User signed in');
        });
        manager.events.addUserSignedOut(() => {
            this.error('User signed out');
            this.errorLogging.logError('auth.warn', 'User signed out');
        });
        manager.events.addUserLoaded((user) => {
            this.log('addUserLoaded', 'Emit user', user);
            this.errorLogging.logError('auth.warn', 'User loaded: ' + JSON.stringify(user));
            this.fields.subjects.user.next(user);
        });
        manager.events.addUserUnloaded(() => {
            this.log('addUserUnloaded', 'Emit user === null');
            this.errorLogging.logError('auth.warn', 'User unloaded');
            this.fields.subjects.user.next(null);
        });
        manager.events.addUserSessionChanged(() => {
            this.log('User session changed');
            this.errorLogging.logError('auth.warn', 'User session changed');
        });
    }
    // private removeUser() {
    //   this.log('AUTHREDIRECT', 'Delete oidc entries');
    //   for (const key of Object.keys(localStorage)) {
    //     if (key.startsWith('oidc.')) {
    //       localStorage.removeItem(key);
    //     }
    //   }
    // }
    getClaims() {
        return this.fields.observables.user.pipe(map$1(user => user.profile));
    }
    getIdToken() {
        return this.fields.observables.idToken;
    }
    getAccessToken() {
        return this.fields.observables.accessToken;
    }
    getUser() {
        return this.fields.observables.user;
    }
    getAuthenticationStatus() {
        return this.fields.observables.authenticationStatus;
    }
    startAuthentication(options) {
        return this.fields.observables.manager.pipe(take(1), tap$1(() => this.log('Manager loaded')), 
        // mergeMap(manager => from(manager.clearStaleState()).pipe(map(() => manager))),
        mergeMap$1(manager => from(manager.removeUser()).pipe(map$1(() => manager))), 
        // mergeMap(manager => {
        //   this.removeUser();
        //   return of(manager);
        // }),
        tap$1(() => this.log('Removed existing user tokens')), mergeMap$1(manager => from(manager.signinRedirect({ extraQueryParams: options?.customParams, redirectMethod: 'replace' }))), tap$1(() => this.log('Executed signinRedirect')), catchError$1(error => {
            this.errorLogging.logError({ source: 'auth.error[8]', error: error });
            return this.errorLogging.sendMessagesToWebService().pipe(tap$1(() => {
                throw error;
            }));
        }), tap$1(() => this.log('return from signinRedirect')), mergeMap$1(() => of('started')));
    }
    completeAuthentication() {
        return this.fields.observables.manager.pipe(take(1), mergeMap$1(manager => {
            const urlParams = new URLSearchParams(location.search);
            if (urlParams.has('state') && urlParams.has('code') && urlParams.has('scope') && urlParams.has('session_state')) {
                return from(manager.signinRedirectCallback()).pipe(catchError$1((error) => {
                    this.errorLogging.logError({ source: 'auth.error[9]', error: error });
                    if (error && error.message === 'No matching state found in storage') {
                        this.clearServiceWorkerCache();
                        return this.errorLogging.sendMessagesToWebService().pipe(mergeMap$1(() => this.router.navigateByUrl('/')), catchError$1(error => {
                            this.errorLogging.logError({ source: 'auth.error[10]', error: error });
                            return this.errorLogging.sendMessagesToWebService().pipe(mergeMap$1(() => this.router.navigateByUrl('/unauthorized'))); // Unauthorized
                        }));
                    }
                    else {
                        this.errorLogging.logError({ source: 'auth.error[11]', error: error });
                        return this.errorLogging.sendMessagesToWebService().pipe(mergeMap$1(() => this.router.navigateByUrl('/unauthorized'))); // Unauthorized
                    }
                }));
            }
            else {
                this.errorLogging.logError('auth.error[12]', 'Not signed in because the return URL did not contain the expected parameters');
                return this.errorLogging.sendMessagesToWebService().pipe(map$1(() => false)); // Not signed in
            }
        }), mergeMap$1(() => of('completed')));
    }
    signOut() {
        this.log('AUTH', 'signOut', 'Start');
        return this.fields.observables.manager.pipe(take(1), tap$1(() => this.log('AUTH', 'signOut', 'call signoutRedirect')), mergeMap$1(manager => from(manager.signoutRedirect())), catchError$1(error => {
            this.errorLogging.logError({ source: 'auth.error[13]', error: error });
            return this.errorLogging.sendMessagesToWebService().pipe(tap$1(() => {
                throw error;
            }));
        }), tap$1(() => this.log('AUTH', 'signOut', 'signoutRedirect completed')), mergeMap$1(() => of('started')));
    }
    refreshSession() {
        this.log('AUTH', 'refreshSession', 'call signinSilent');
        return from(this.fields.auth.manager.signinSilent()).pipe(tap$1(() => this.log('AUTH', 'refreshSession', 'signinSilent done')), catchError$1(error => {
            this.errorLogging.logError({ source: 'auth.error[14]', error: error });
            return this.errorLogging.sendMessagesToWebService().pipe(tap$1(() => {
                throw error;
            }));
        }));
    }
    log(...values) {
        if (this.diagnostic.loggingOptions.authentication) {
            this.cachedLogger.log(...values);
        }
    }
    error(...values) {
        if (this.diagnostic.loggingOptions.authentication) {
            this.cachedLogger.error(...values);
        }
    }
    clearServiceWorkerCache() {
        if ('caches' in window) {
            this.log('CACHE', 'found');
            from(caches.keys())
                .pipe(mergeMap$1(keyList => Promise.all(keyList.map(key => caches.delete(key)))))
                .subscribe(keyList => {
                this.log('CACHE', keyList);
            });
        }
    }
    dateAfterNow(tokenExpiry) {
        return tokenExpiry > Date.now() / 1000;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AuthLibProxyService, deps: [{ token: CitadelDiagnosticsService }, { token: i1$1.Router }, { token: CachedAuthLoggerService }, { token: CitadelErrorLoggingService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AuthLibProxyService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AuthLibProxyService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: CitadelDiagnosticsService }, { type: i1$1.Router }, { type: CachedAuthLoggerService }, { type: CitadelErrorLoggingService }] });

var AuthorizationEvent;
(function (AuthorizationEvent) {
    AuthorizationEvent[AuthorizationEvent["ConfigLoaded"] = 0] = "ConfigLoaded";
    AuthorizationEvent[AuthorizationEvent["CheckSessionReceived"] = 1] = "CheckSessionReceived";
    AuthorizationEvent[AuthorizationEvent["UserDataChanged"] = 2] = "UserDataChanged";
    AuthorizationEvent[AuthorizationEvent["NewAuthorizationResult"] = 3] = "NewAuthorizationResult";
    AuthorizationEvent[AuthorizationEvent["TokenExpired"] = 4] = "TokenExpired";
    AuthorizationEvent[AuthorizationEvent["IdTokenExpired"] = 5] = "IdTokenExpired";
})(AuthorizationEvent || (AuthorizationEvent = {}));
const redirectBlacklist = [
    '/auth-callback',
    '/unauthorized',
    '/testing',
    'sign-in',
    'redirect',
    'auth.citadel.co.za',
    'dev-auth.citadel.co.za',
    'staging-auth.citadel.co.za',
    'preprod-auth.citadel.co.za',
    'support-auth.citadel.co.za',
    'auth.citazen.co.za',
    'app-citazen-auth-development.citazen.co.za',
    'app-citazen-auth-staging.citazen.co.za',
    'app-citazen-auth-preprod.citazen.co.za',
    'app-citazen-auth-support.citazen.co.za',
    'silent-renew.html',
];
class CitadelAuthService {
    get applicationName() {
        return this.fields.applicationName;
    }
    get wellKnownEndpoints() {
        return { ...this.fields.endpoints };
    }
    get sessionTimeout() {
        return this.fields.timeout.value;
    }
    set sessionTimeout(value) {
        if (typeof value === 'number' && value >= this.fields.timeout.min || value === undefined) {
            this.fields.timeout.value = value;
        }
        else {
            throw Error(`Invalid session timeout: ${value}`);
        }
    }
    get sessionWarningTimeout() {
        return this.fields.warningTime.value;
    }
    set sessionWarningTimeout(value) {
        if (typeof value === 'number' && value > this.fields.warningTime.min || value === undefined) {
            this.fields.warningTime.value = value;
        }
        else {
            throw Error(`Invalid session timeout: ${value}`);
        }
    }
    constructor(authProxy, router, location, diagnostic) {
        this.authProxy = authProxy;
        this.router = router;
        this.location = location;
        this.diagnostic = diagnostic;
        this.wellknownPrefix = '/.well-known/openid-configuration';
        this.fields = {
            impersonationStarted: false,
            applicationName: '',
            endpoints: {
                userInfo: `${this.wellknownPrefix}/userinfo`,
            },
            timeout: {
                min: 300,
                value: undefined,
                handle: undefined,
            },
            warningTime: {
                min: 60,
                value: 60,
                handle: undefined,
            },
            subjects: {
                timeoutWarning: new Subject(),
                events: {
                    0: new Subject(),
                    1: new Subject(),
                    2: new Subject(),
                    3: new Subject(),
                    4: new Subject(),
                    5: new Subject(),
                },
            },
            observables: {
                timeoutWarning: undefined,
                isAuthenticated: undefined,
                events: {
                    0: undefined,
                    1: undefined,
                    2: undefined,
                    3: undefined,
                    4: undefined,
                    5: undefined,
                },
            },
        };
        this.themeName = 'Citazen Default';
        this.fields.observables.timeoutWarning = this.fields.subjects.timeoutWarning.asObservable();
        this.fields.observables.isAuthenticated = this.authProxy.getAuthenticationStatus().pipe(map(status => status === 'authenticated'));
    }
    initAuth(applicationName, authSettings) {
        const urlKey = 'Services:Citadel.Auth';
        const baseHref = this.location.prepareExternalUrl('');
        const originUrl = Location.joinWithSlash(document.location.origin, baseHref);
        const scopes = Object.keys(authSettings).filter(key => key !== urlKey).map(key => authSettings[key]).reduce((prev, current) => `${prev} ${current}`);
        const stsServer = Location.stripTrailingSlash(authSettings[urlKey]);
        this.fields.applicationName = applicationName;
        this.authProxy.setConfig(of({
            authority: stsServer,
            clientID: applicationName,
            redirectUri: Location.joinWithSlash(originUrl, 'auth-callback'),
            silentRenewRedirectUri: Location.joinWithSlash(originUrl, 'assets/silent-renew.html'),
            scope: scopes,
            staleStateAgeInSeconds: 9000,
        }));
    }
    navigateToStoredEndpoint() {
        this.log('AUTH', 'navigateToStoredEndpoint', 'Start');
        const path = this.calculateTargetEndpoint();
        this.log('AUTH', 'navigateToStoredEndpoint', 'path:', path, 'router URL:', this.router.url);
        if (this.router.url === path) {
            return;
        }
        this.log('AUTH', 'navigateToStoredEndpoint', 'Starting navigation to', path);
        localStorage.removeItem('auth_redirect');
        from(this.router.navigateByUrl(path))
            .pipe(catchError(_ => this.router.navigate(['/'])))
            .subscribe(success => {
            if (!success) {
                this.log('AUTH', 'navigateToStoredEndpoint', 'Navigation failed, reverting to /');
                this.router.navigate(['/']);
            }
            else {
                this.log('AUTH', 'navigateToStoredEndpoint', 'Navigation complete');
            }
        });
    }
    calculateTargetEndpoint() {
        const stored = this.read('auth_redirect') || '';
        this.log('AUTHREDIRECT', 'reading', stored);
        if (redirectBlacklist.find(entry => stored.indexOf(entry) !== -1)) {
            this.log('AUTH', 'CalculateTargetEndpoint', 'Overriding route to / from', stored);
            return '/';
        }
        else {
            this.log('AUTH', 'CalculateTargetEndpoint', 'Using stored endpoint', stored);
            return stored;
        }
    }
    signIn(authOptions) {
        const newOptions = authOptions || {};
        newOptions.customParams = newOptions['customParams'] || {};
        newOptions.customParams['authRedirect'] = this.read('auth_redirect');
        if (!newOptions.customParams.prompt) {
            newOptions.customParams.prompt = 'login';
        }
        if (!newOptions.customParams.t) {
            newOptions.customParams.t = this.themeName;
        }
        this.log('start sign-in');
        this.authProxy.startAuthentication(newOptions).subscribe(() => this.log('Signed in'));
    }
    completeAuthentication() {
        return this.authProxy.completeAuthentication();
    }
    refreshSession() {
        this.log('start refreshSession');
        return this.authProxy.refreshSession();
    }
    signOut() {
        this.log('start sign-out');
        this.authProxy.signOut().subscribe(result => this.log('Signed out', result));
    }
    get isAuthenticated() {
        return this.fields.observables.isAuthenticated;
    }
    get user() {
        return this.authProxy.getUser();
    }
    get impersonationStarted() {
        return this.fields.impersonationStarted;
    }
    impersonate(id) {
        this.fields.impersonationStarted = true;
        this.signIn({ customParams: { impersonate: id } });
    }
    getToken(resetSession) {
        if (resetSession || resetSession === undefined || resetSession === null) {
            this.restartSessionTimeout();
        }
        const token = this.authProxy.getAccessToken().pipe(take$1(1));
        return token;
    }
    restartSessionTimeout() {
        if (this.fields.timeout.handle) {
            this.log('Clearing session token');
            clearTimeout(this.fields.timeout.handle);
            this.fields.timeout.handle = undefined;
        }
        if (this.fields.warningTime.handle) {
            clearTimeout(this.fields.warningTime.handle);
            this.fields.warningTime.handle = undefined;
        }
        if (this.fields.timeout.value) {
            this.log('Starting new refresh period for', this.fields.timeout.value, 'seconds');
            this.fields.timeout.handle = setTimeout(() => this.emitTimeout(), this.fields.timeout.value * 1000);
            this.fields.warningTime.handle = setTimeout(() => this.emitWarningTime(), Math.max(0, this.fields.timeout.value - this.fields.warningTime.value) * 1000);
        }
    }
    getSessionTimeoutWarning() {
        return this.fields.observables.timeoutWarning;
    }
    getConfigLoaded() {
        return this.fields.observables.events[0];
    }
    getCheckSessionReceived() {
        return this.fields.observables.events[1];
    }
    getNewAuthorizationResult() {
        return this.fields.observables.events[3];
    }
    getTokenExpired() {
        return this.fields.observables.events[4];
    }
    getIdTokenExpired() {
        return this.fields.observables.events[4];
    }
    testPassword(password) {
        const characters = password.match(/[a-zA-Z ]/g);
        const lowers = password.match(/[a-z]/g);
        const uppers = password.match(/[A-Z]/g);
        let score = 0;
        if (characters) {
            score += 0.2 * Math.pow(characters.length, 2) + 39;
        }
        else {
            score = -70;
        }
        const specials = password.match(/(?![0-9a-zA-Z ])./g);
        const numbers = password.match(/[0-9]/g);
        if (specials) {
            for (let i = 0; i < specials.length; i++) {
                score += 7;
            }
        }
        if (numbers) {
            for (let i = 0; i < numbers.length; i++) {
                score += 7;
            }
        }
        if (password.length < 8 || !(specials && specials.length > 0) || !(numbers && numbers.length > 0) || !(lowers && lowers.length > 0) || !(uppers && uppers.length > 0)) {
            score = score > 60 ? 60 : score;
        }
        return score > 100 ? 100 : (score < 0 ? 0 : score);
    }
    emitEvent(event) {
        const subject = this.fields.subjects.events[event.type];
        if (subject) {
            subject.next(event.value);
        }
    }
    emitTimeout() {
        this.isAuthenticated.pipe(tap(isAuthorized => this.log('AUTH', 'emitTimeout', 'isAuthorized', isAuthorized)), take$1(1)).pipe(tap(isAuthenticated => {
            if (isAuthenticated) {
                this.log('Session timing out');
            }
            else {
                this.log('Session timeout requested, but the user is not signed in');
            }
        }), filter$1(isAuthenticated => !!isAuthenticated), mergeMap(_ => this.authProxy.signOut())).subscribe(_ => this.log('Session expired'));
    }
    emitWarningTime() {
        this.fields.subjects.timeoutWarning.next(this.fields.warningTime.value);
    }
    read(key) {
        const data = localStorage.getItem(key);
        if (data) {
            if (typeof data === 'string') {
                return data;
            }
            else {
                return JSON.parse(data);
            }
        }
        return;
    }
    write(key, value) {
        if (key === 'auth_redirect') {
            localStorage.removeItem('redirect');
            localStorage.removeItem('Citadel.Launcher.Citazen_storageSilentRenewRunning');
            localStorage.removeItem('Citadel.Launcher.Msz_storageSilentRenewRunning');
            value = redirectBlacklist.find(entry => window.location.pathname.indexOf(entry) !== -1) ? '/' : window.location.pathname + window.location.search;
        }
        if (typeof value === 'string') {
            localStorage.setItem(key, value);
        }
        else {
            localStorage.setItem(key, JSON.stringify(value));
        }
    }
    log(...values) {
        if (this.diagnostic.loggingOptions.authentication) {
            console.log(...values);
        }
    }
    error(...values) {
        if (this.diagnostic.loggingOptions.authentication) {
            console.error(...values);
        }
    }
    storeActiveRoute() {
        if (window && location) {
            const redirectPath = redirectBlacklist.find(entry => window.location.pathname.indexOf(entry) !== -1) ? '/' : window.location.pathname + window.location.search;
            if (!!redirectPath && redirectPath !== '/') {
                this.log('AUTHREDIRECT', 'writing', redirectPath);
                this.write('auth_redirect', redirectPath);
            }
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelAuthService, deps: [{ token: AuthLibProxyService }, { token: i1$1.Router }, { token: i2.Location }, { token: CitadelDiagnosticsService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelAuthService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelAuthService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: AuthLibProxyService }, { type: i1$1.Router }, { type: i2.Location }, { type: CitadelDiagnosticsService }] });

class CitadelWebService {
    get activeCalls() {
        return this.fields.activeCalls;
    }
    set activeCalls(value) {
        if (value <= 0) {
            this.fields.activeCalls = 0;
        }
        else {
            this.fields.activeCalls = value;
        }
        setTimeout(() => this.busy$.next(this.activeCalls > 0));
    }
    get hasServiceRegistry() {
        return this.fields.hasServiceRegistry;
    }
    get isBusy() {
        return this.busyUnique$;
    }
    constructor(http, alert, handler, auth) {
        this.http = http;
        this.alert = alert;
        this.handler = handler;
        this.auth = auth;
        this.fields = {
            activeCalls: 0,
            hasServiceRegistry: false,
            serviceRegistry: {},
            notifiers: {},
        };
        this.busy$ = new BehaviorSubject(false);
        this.busyUnique$ = this.busy$.pipe(distinctUntilChanged());
    }
    addServicesFromConfig(config$, ...entries) {
        this.fields.hasServiceRegistry = true;
        for (const entry of entries) {
            this.fields.serviceRegistry[entry.name || `${entry.serviceConfigName},${entry.controllerName}`] = {
                url: config$.pipe(map((config) => config.get(entry.serviceConfigName))),
                controllerName: entry.controllerName,
                options: entry.options || {}
            };
            if (this.fields.notifiers[entry.name]) {
                this.fields.notifiers[entry.name].next(entry.name);
            }
        }
    }
    addServiceRegistry(name, url, options) {
        this.fields.hasServiceRegistry = true;
        if (!name || !url) {
            throw new Error(`Could not register '${name}' with the service registry, because either name or url was invalid.`);
        }
        this.fields.serviceRegistry[name] = {
            url: new BehaviorSubject(url),
            options: options || {}
        };
    }
    waitFor(name) {
        if (!this.fields.notifiers[name]) {
            this.fields.notifiers[name] = new ReplaySubject(1);
        }
        return this.fields.notifiers[name];
    }
    get(name, params, webOptions, responseType) {
        webOptions = webOptions || {};
        const { key, call } = this.getCallParts(name);
        const { url, controllerName, options } = this.getServiceRegistryEntry(key);
        if (!url) {
            throw new Error(`"${key}" is not a valid service.`);
        }
        const callOptions = { ...options };
        if (webOptions.observe && webOptions.observe.length > 0) {
            callOptions['observe'] = webOptions.observe;
        }
        if (webOptions.responseType && webOptions.responseType.length > 0) {
            callOptions['responseType'] = webOptions.responseType;
        }
        else if (responseType && responseType.length > 0) {
            callOptions['responseType'] = responseType;
        }
        if (typeof (params) === 'object') {
            callOptions['params'] = this.objectToParameters(params);
        }
        if (webOptions.headers) {
            callOptions['headers'] = this.createHeaders(webOptions.headers);
        }
        if (!webOptions.noLoader) {
            this.activeCalls++;
        }
        return url
            // Assemble the URL from the registry
            .pipe(map((baseUrl) => this.prepareUrl(baseUrl, controllerName, call, params, webOptions)))
            // Call the service
            .pipe(mergeMap((finalUrl) => this.http.get(finalUrl, callOptions).pipe(map(value => this.convertAllGuidsToUpperCase(value, webOptions)))))
            // Retry twice before failing, only if it's a server error (5XX range)
            .pipe(retryWhen(error => error.pipe(concatMap((err, idx) => iif(() => (idx > 2 /*|| err.status < 500*/), throwError(err), of(err).pipe(delay(1000)))))))
            // If there is an error, show a message to the user
            .pipe(catchError((err) => this.defaultErrorHandler(err, webOptions, 'There was an error getting data')))
            // Whatever else happened, decrement the active call count so the spinner can update
            .pipe(finalize(() => {
            if (!webOptions.noLoader) {
                this.activeCalls--;
            }
        }))
            // Complete the observable (this is needed to resolve the promise created by toPromise)
            .pipe(take$1(1));
    }
    post(serviceName, params, webOptions) {
        webOptions = webOptions || {};
        const { key, call } = this.getCallParts(serviceName);
        const { url, controllerName, options } = this.getServiceRegistryEntry(key);
        if (!url) {
            throw new Error(`"${key}" is not a valid service.`);
        }
        const callOptions = { ...options };
        if (webOptions.observe && webOptions.observe.length > 0) {
            callOptions['observe'] = webOptions.observe;
        }
        if (webOptions.responseType && webOptions.responseType.length > 0) {
            callOptions['responseType'] = webOptions.responseType;
        }
        if (webOptions.headers) {
            callOptions['headers'] = this.createHeaders(webOptions.headers);
        }
        if (!webOptions.noLoader) {
            this.activeCalls++;
        }
        return url
            // Assemble the URL from the registry
            .pipe(map((baseUrl) => this.prepareUrl(baseUrl, controllerName, call, params, webOptions)))
            // Call the service
            .pipe(mergeMap((finalUrl) => this.http.post(finalUrl, this.parameterToBody(params), callOptions).pipe(map(value => this.convertAllGuidsToUpperCase(value, webOptions)))))
            // If there is an error, show a message to the user
            .pipe(catchError((err) => this.defaultErrorHandler(err, webOptions)))
            // Whatever else happened, decrement the active call count so the spinner can update
            .pipe(finalize(() => {
            if (!webOptions.noLoader) {
                this.activeCalls--;
            }
        }))
            // Complete the observable (this is needed to resolve the promise created by toPromise)
            .pipe(take$1(1));
    }
    put(serviceName, params, webOptions) {
        webOptions = webOptions || {};
        const { key, call } = this.getCallParts(serviceName);
        const { url, controllerName, options } = this.getServiceRegistryEntry(key);
        if (!url) {
            throw new Error(`"${key}" is not a valid service.`);
        }
        const callOptions = { ...options };
        callOptions['body'] = params;
        if (webOptions.observe && webOptions.observe.length > 0) {
            callOptions['observe'] = webOptions.observe;
        }
        if (webOptions.responseType && webOptions.responseType.length > 0) {
            callOptions['responseType'] = webOptions.responseType;
        }
        if (webOptions.headers) {
            callOptions['headers'] = this.createHeaders(webOptions.headers);
        }
        if (!webOptions.noLoader) {
            this.activeCalls++;
        }
        return url
            // Assemble the URL from the registry
            .pipe(map((baseUrl) => this.prepareUrl(baseUrl, controllerName, call, params, webOptions)))
            // Call the service
            .pipe(mergeMap((finalUrl) => this.http.put(finalUrl, this.parameterToBody(params), callOptions).pipe(map(value => this.convertAllGuidsToUpperCase(value, webOptions)))))
            // If there is an error, show a message to the user
            .pipe(catchError((err) => this.defaultErrorHandler(err, webOptions)))
            // Whatever else happened, decrement the active call count so the spinner can update
            .pipe(finalize(() => {
            if (!webOptions.noLoader) {
                this.activeCalls--;
            }
        }))
            // Complete the observable (this is needed to resolve the promise created by toPromise)
            .pipe(take$1(1));
    }
    delete(serviceName, params, webOptions) {
        webOptions = webOptions || {};
        const { key, call } = this.getCallParts(serviceName);
        const { url, controllerName, options } = this.getServiceRegistryEntry(key);
        if (!url) {
            throw new Error(`"${key}" is not a valid service.`);
        }
        const callOptions = { ...options };
        if (typeof (params) === 'object') {
            callOptions['params'] = params;
        }
        if (webOptions.observe && webOptions.observe.length > 0) {
            callOptions['observe'] = webOptions.observe;
        }
        if (webOptions.responseType && webOptions.responseType.length > 0) {
            callOptions['responseType'] = webOptions.responseType;
        }
        if (webOptions.headers) {
            callOptions['headers'] = this.createHeaders(webOptions.headers);
        }
        if (!webOptions.noLoader) {
            this.activeCalls++;
        }
        return url
            // Assemble the URL from the registry
            .pipe(map((baseUrl) => this.prepareUrl(baseUrl, controllerName, call, params, webOptions)))
            // Call the service
            .pipe(mergeMap((finalUrl) => this.http.delete(finalUrl, callOptions).pipe(map(value => this.convertAllGuidsToUpperCase(value, webOptions)))))
            // If there is an error, show a message to the user
            .pipe(catchError((err) => this.defaultErrorHandler(err, webOptions, 'There was an error changing data')))
            // Whatever else happened, decrement the active call count so the spinner can update
            .pipe(finalize(() => {
            if (!webOptions.noLoader) {
                this.activeCalls--;
            }
        }))
            // Complete the observable (this is needed to resolve the promise created by toPromise)
            .pipe(take$1(1));
    }
    insert(serviceName, params, webOptions) {
        if (!Array.isArray(params)) {
            params = [params];
        }
        if (webOptions && !webOptions.getMessage) {
            webOptions.getMessage = () => 'There was an error changing data';
        }
        return this.post(serviceName, params, webOptions);
    }
    update(serviceName, params, webOptions) {
        if (webOptions && !webOptions.getMessage) {
            webOptions.getMessage = () => 'There was an error changing data';
        }
        return this.post(serviceName, params, webOptions);
    }
    merge(serviceName, params, webOptions) {
        if (params['id']) {
            return this.update(serviceName, params, webOptions);
        }
        else {
            return this.insert(serviceName, params, webOptions);
        }
    }
    upload(serviceName, body, webOptions) {
        webOptions = webOptions || {};
        const { key, call } = this.getCallParts(serviceName);
        const { url, controllerName } = this.getServiceRegistryEntry(key);
        if (!url) {
            throw new Error(`"${key}" is not a valid service.`);
        }
        const formData = new FormData();
        for (const prop in body) {
            if (body.hasOwnProperty(prop)) {
                formData.append(prop, body[prop]);
            }
        }
        const httpClient = new HttpClient(this.handler);
        if (!webOptions.noLoader) {
            this.activeCalls++;
        }
        return url
            // Assemble the URL from the registry
            .pipe(map((baseUrl) => this.prepareUrl(baseUrl, controllerName, call, formData, {})))
            // Get the access token
            .pipe(switchMap((finalUrl) => this.auth.getToken().pipe(map(token => {
            const options = {
                finalUrl: finalUrl,
                headers: new HttpHeaders({ 'Authorization': `Bearer ${token}` }),
            };
            if (webOptions.responseType) {
                options['responseType'] = webOptions.responseType;
            }
            if (webOptions.reportProgress) {
                options['reportProgress'] = webOptions.reportProgress;
            }
            if (webOptions.observe) {
                options['observe'] = webOptions.observe;
            }
            return options;
        }))))
            // Call the service
            .pipe(mergeMap((options) => {
            const finalUrl = options.finalUrl;
            delete options.finalUrl;
            return httpClient.post(finalUrl, formData, options);
        }))
            // If there is an error, show a message to the user
            .pipe(catchError((err) => this.defaultErrorHandler(err, webOptions)))
            // Whatever else happened, decrement the active call count so the spinner can update
            .pipe(finalize(() => {
            if (!webOptions.noLoader) {
                this.activeCalls--;
            }
        }))
            // Complete the observable (this is needed to resolve the promise created by toPromise)
            .pipe(take$1(1));
    }
    createHeaders(headers) {
        if (!headers) {
            return undefined;
        }
        return new HttpHeaders(headers);
    }
    createDownloadLink(serviceName, params) {
        const { key, call } = this.getCallParts(serviceName);
        const { url, controllerName, options } = this.getServiceRegistryEntry(key);
        if (!url) {
            throw new Error(`"${key}" is not a valid service.`);
        }
        const callOptions = { ...options };
        if (typeof (params) === 'object') {
            callOptions['params'] = this.objectToParameters(params);
        }
        return url.pipe(map((baseUrl) => this.prepareUrl(baseUrl, controllerName, call, params, {})));
    }
    download(base64, fileName, type = 'pdf') {
        if (!document) {
            return;
        }
        const arrBuffer = this.base64ToArrayBuffer(base64);
        const newBlob = new Blob([arrBuffer], { type: 'application/' + type });
        // if (window.navigator && window.navigator.msSaveOrOpenBlob) { // Internet Explorer, oh dear
        //   window.navigator.msSaveOrOpenBlob(newBlob, fileName);
        //   return;
        // }
        const data = window.URL.createObjectURL(newBlob);
        const link = document.createElement('a');
        link.style.display = 'none';
        document.body.appendChild(link); // Required in FF, optional for Chrome
        link.href = data;
        link.download = fileName;
        link.click();
        window.URL.revokeObjectURL(data);
        link.remove();
    }
    getErrorMessage(err, options, defaultMessage) {
        let errMessage;
        if (options && options.getMessage) {
            errMessage = options.getMessage(err);
        }
        return errMessage || defaultMessage;
    }
    getCallParts(name) {
        if (!this.hasServiceRegistry) {
            return { key: undefined, call: undefined };
        }
        const split = name.indexOf('/');
        let key;
        let call;
        if (split === -1) {
            key = name;
        }
        else {
            key = name.substring(0, split);
            call = name.substring(split + 1);
        }
        if (!key) {
            throw new Error(`"${name}" is not a valid service.`);
        }
        return { key, call };
    }
    getServiceRegistryEntry(name) {
        const entry = this.fields.serviceRegistry[name];
        let result;
        if (entry) {
            result = entry;
        }
        else if (this.hasServiceRegistry) {
            result = { url: undefined, controllerName: undefined, options: undefined };
        }
        else {
            result = { url: new BehaviorSubject(name), controllerName: undefined, options: undefined };
        }
        return result;
    }
    prepareUrl(baseUrl, controllerName, call, params, webOptions) {
        try {
            let result = baseUrl;
            const url = new URL(result);
            if (url.pathname.indexOf('/api') === -1 && !webOptions.noNormalization) {
                result = Location.joinWithSlash(result, 'api');
            }
            if (controllerName) {
                result = Location.joinWithSlash(result, controllerName);
            }
            if (call) {
                result = Location.joinWithSlash(result, call);
            }
            if (typeof params === 'string') {
                result = Location.joinWithSlash(result, params);
            }
            return result;
        }
        catch (err) {
            if (!baseUrl) {
                console.error('No base URL available. Check if you have the dependency configured and have an addServicesFromConfig entry for', { controllerName, call, params });
                throw 'No base URL available.';
            }
            else {
                console.error('Error calling web service', { controllerName, call, params, err });
            }
        }
    }
    base64ToArrayBuffer(data) {
        const binaryString = window.atob(data);
        const binaryLen = binaryString.length;
        const bytes = new Uint8Array(binaryLen);
        for (let i = 0; i < binaryLen; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }
        return bytes;
    }
    objectToParameters(params) {
        let result;
        for (const field in params) {
            if (params.hasOwnProperty(field) && params[field] !== undefined && params[field] !== null) {
                if (result) {
                    result = result.append(field, params[field]);
                }
                else {
                    result = (new HttpParams({ encoder: new CustomEncoder() })).set(field, params[field]);
                }
            }
        }
        return result;
    }
    parameterToBody(params) {
        if (typeof params === 'object') {
            return params;
        }
        else {
            return undefined;
        }
    }
    defaultErrorHandler(err, options, defaultErrorMessage) {
        if (!options || !options.hideErrorMessage) {
            this.alert.error(this.getErrorMessage(err, options, defaultErrorMessage || 'There was an error communicating with the server'));
        }
        return throwError(err);
    }
    isGuid(value) {
        return !!value.match(/^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/);
    }
    convertAllGuidsToUpperCase(value, webOptions) {
        if (!webOptions || webOptions.guids !== 'uppercase') {
            return value;
        }
        if (Array.isArray(value)) {
            const result = [];
            for (const v of value) {
                result.push(this.convertAllGuidsToUpperCase(v, webOptions));
            }
            return result;
        }
        else if (typeof value === 'object') {
            const result = { ...value };
            for (const key of Object.keys(result)) {
                if (typeof result[key] === 'string' && this.isGuid(result[key])) {
                    result[key] = result[key].toUpperCase();
                }
            }
            return result;
        }
        else {
            return value;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelWebService, deps: [{ token: i1.HttpClient }, { token: CitadelNotificationService }, { token: i1.HttpBackend }, { token: CitadelAuthService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelWebService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelWebService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: i1.HttpClient }, { type: CitadelNotificationService }, { type: i1.HttpBackend }, { type: CitadelAuthService }] });

class CitadelDateService {
    addDays(date, n) {
        date = this.makeDate(date);
        date.setDate(date.getDate() + n);
    }
    addMonths(date, n) {
        date = this.makeDate(date);
        date.setMonth(date.getMonth() + n);
    }
    addYears(date, n) {
        date = this.makeDate(date);
        date.setFullYear(date.getFullYear() + n);
    }
    addHours(date, n) {
        date = this.makeDate(date);
        date.setHours(date.getHours() + n);
    }
    addMinutes(date, n) {
        date = this.makeDate(date);
        date.setMinutes(date.getMinutes() + n);
    }
    addSeconds(date, n) {
        date = this.makeDate(date);
        date.setSeconds(date.getSeconds() + n);
    }
    addMilliSeconds(date, n) {
        date = this.makeDate(date);
        date.setMilliseconds(date.getMilliseconds() + n);
    }
    addQuarters(date, n) {
        date = this.makeDate(date);
        date.setMonth(date.getMonth() + 3 * n);
    }
    addWeeks(date, n) {
        date = this.makeDate(date);
        date.setDate(date.getDate() + 2 * n);
    }
    monthStart(input) {
        return new Date(input.getFullYear(), input.getMonth(), 1);
    }
    monthEnd(input) {
        return new Date(input.getFullYear(), input.getMonth() + 1, 0);
    }
    stripTime(input) {
        return new Date(Date.UTC(input.getFullYear(), input.getMonth(), input.getDate()));
    }
    displayDateText(date) {
        // D MMM YYYY
        date = this.makeDate(date);
        return date.getDate() + " " + this.getMonthName(date.getMonth()) + " " + date.getFullYear();
    }
    displayDateTimeText(date) {
        // D MMM YYYY HH:mm:ss
        date = this.makeDate(date);
        return `${this.displayDateText(date)} ${this.displayTimeText(date)}`;
    }
    displayTimeText(date) {
        // HH:mm:ss
        date = this.makeDate(date);
        return this.formatTime(date.getHours()) + ":" + this.formatTime(date.getMinutes()) + ":" + this.formatTime(date.getSeconds());
    }
    displayDateZA(date) {
        // DD/MM/YYYY
        date = this.makeDate(date);
        return this.formatTime(date.getDate()) + "/" + this.formatTime(date.getMonth() + 1) + "/" + date.getFullYear();
    }
    displayDateTimeZA(date) {
        // DD/MM/YYYY HH:mm:ss
        date = this.makeDate(date);
        return `${this.displayDateZA(date)} ${this.displayTimeText(date)}`;
    }
    displayDateISO(date) {
        // YYYY-MM-DD
        date = this.makeDate(date);
        return date.getFullYear() + "-" + this.formatTime(date.getMonth() + 1) + "-" + this.formatTime(date.getDate());
    }
    displayDateTimeISO(date) {
        // YYYY-MM-DD HH:mm:ss
        date = this.makeDate(date);
        return `${this.displayDateISO(date)} ${this.displayTimeText(date)}`;
    }
    getMonthName(monthIndex) {
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        return months[monthIndex];
    }
    formatTime(timeValue) {
        return (timeValue < 10 ? '0' : '') + timeValue;
    }
    makeDate(d) {
        if (typeof d === 'string' || typeof d === 'number') {
            return new Date(d);
        }
        else {
            return d;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelDateService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelDateService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelDateService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

class CitadelAuthInterceptor {
    constructor(auth, diagnostics) {
        this.auth = auth;
        this.diagnostics = diagnostics;
        this.isAuthenticated = false;
        this.noResetUrls = [
            'citazen.co.za/api/msz/Structure/getNotifications',
            'citazen.co.za/api/citazen-config/Maintenance/',
        ];
        this.auth.isAuthenticated.pipe(tap$1(isAuthorized => {
            if (this.diagnostics.loggingOptions.authentication) {
                console.log('AUTHINTERCEPT', 'isAuthorized', isAuthorized);
            }
        })).subscribe(isAuthenticated => this.isAuthenticated = isAuthenticated);
    }
    intercept(req, next) {
        if (!req.headers.has('Content-Type')) {
            req = req.clone({
                headers: req.headers.set('Content-Type', 'application/json')
            });
        }
        if (this.isAuthenticated && !req.headers.has('Authorization')) {
            return this.auth.getToken(this.mustResetTimeout(req)).pipe(switchMap$1(token => next.handle(this.addTokenToRequest(req, token))));
        }
        else {
            return next.handle(req);
        }
    }
    addTokenToRequest(request, token) {
        if (this.diagnostics.loggingOptions.authentication) {
            console.log(`Adding token to ${request.urlWithParams}`);
            console.log({ token });
        }
        const newHeaders = {
            'Authorization': `Bearer ${token}`
        };
        return request.clone({ setHeaders: newHeaders });
    }
    mustResetTimeout(req) {
        for (const url of this.diagnostics.noResetUrls) {
            if (req.url.includes(url)) {
                return false;
            }
        }
        return true;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelAuthInterceptor, deps: [{ token: CitadelAuthService }, { token: CitadelDiagnosticsService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelAuthInterceptor }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelAuthInterceptor, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: CitadelAuthService }, { type: CitadelDiagnosticsService }] });

var lkpPermissionType;
(function (lkpPermissionType) {
    lkpPermissionType[lkpPermissionType["read"] = 0] = "read";
    lkpPermissionType[lkpPermissionType["write"] = 1] = "write";
})(lkpPermissionType || (lkpPermissionType = {}));
var lkpAuthRoleType;
(function (lkpAuthRoleType) {
    lkpAuthRoleType[lkpAuthRoleType["system"] = 0] = "system";
    lkpAuthRoleType[lkpAuthRoleType["organization"] = 1] = "organization";
    lkpAuthRoleType[lkpAuthRoleType["user"] = 2] = "user";
})(lkpAuthRoleType || (lkpAuthRoleType = {}));
var lkpAuthenticationType;
(function (lkpAuthenticationType) {
    lkpAuthenticationType[lkpAuthenticationType["email"] = 0] = "email";
    lkpAuthenticationType[lkpAuthenticationType["citadelActiveDirectory"] = 1] = "citadelActiveDirectory";
    lkpAuthenticationType[lkpAuthenticationType["bSolveActiveDirectory"] = 2] = "bSolveActiveDirectory";
})(lkpAuthenticationType || (lkpAuthenticationType = {}));
class AuthUser {
    constructor(userData) {
        this.id = userData.id;
        this.userName = userData.userName;
        this.name = userData.name;
        this.firstName = userData.firstName;
        this.surname = userData.surname || userData.lastName;
        this.emailAddress = userData.emailAddress || userData.userName;
        this.otpNumber = userData.otpNumber;
        this.isBlocked = userData.isBlocked;
        this.authenticationType = userData.authenticationType;
        this.permissions = this.loadPermissions(userData.permissions);
        this.roles = this.loadRoles(userData.roles);
        this.systemNumber = userData.systemNumber;
    }
    permissionType(permissionCode) {
        return this.permissions[permissionCode];
    }
    hasPermission(permissionCode) {
        return this.permissionType(permissionCode) !== undefined;
    }
    hasMatchingReadPermission(input) {
        for (const permission of input) {
            if (this.permissionType(permission) === lkpPermissionType.read) {
                return true;
            }
        }
        return false;
    }
    hasMatchingWritePermission(input) {
        for (const permission of input) {
            if (this.permissionType(permission) === lkpPermissionType.write) {
                return true;
            }
        }
        return false;
    }
    hasRole(role) {
        return !!this.roles.find(r => r.id === role || r.label === role);
    }
    loadImpersonator(authData) {
        const impersonator = {
            id: authData.impersonatorID,
            name: authData.impersonatorName,
            userName: authData.impersonatorUserName,
        };
        if (impersonator.id) {
            this.impersonator = impersonator;
        }
        return this;
    }
    loadPermissions(permissionList) {
        if (!Array.isArray(permissionList)) {
            return {};
        }
        const result = permissionList.reduce((prev, current) => {
            const key = current.code;
            const writeExists = current.types.find(type => type.permissionType > 0);
            const type = writeExists === undefined ? lkpPermissionType.read : lkpPermissionType.write;
            const result = { ...prev };
            result[key] = type;
            return result;
        }, {});
        return result;
    }
    loadRoles(roleList) {
        const result = roleList.map(input => {
            return {
                id: input.id,
                label: input.label,
                type: input.type,
            };
        });
        return result;
    }
}

class CitadelUserInfoLoaderService {
    constructor(web) {
        this.web = web;
    }
    loadCurrentUser() {
        return this.web.waitFor('Citadel.Auth.User').pipe(mergeMap$1(() => this.web.get('Citadel.Auth.User')));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelUserInfoLoaderService, deps: [{ token: CitadelWebService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelUserInfoLoaderService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelUserInfoLoaderService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: CitadelWebService }] });

class CitadelUserService {
    constructor(authService, web, diagnostic, userLoader) {
        this.authService = authService;
        this.web = web;
        this.diagnostic = diagnostic;
        this.userLoader = userLoader;
        this.fields = {
            hasLoaded: false,
            subjects: {
                user: new ReplaySubject(1),
                isLoadingComplete: new ReplaySubject(1),
            },
            observables: {
                user: undefined,
            },
            pauser: undefined,
        };
        this.createUserObservable();
    }
    createUserObservable() {
        this.fields.observables.user = zip([
            this.fields.subjects.user.asObservable().pipe(pausedBy(this.fields.pauser), tap(value => this.log('USERAUTH', value))),
            this.fields.subjects.isLoadingComplete.asObservable().pipe(filter$1(isLoadingComplete => !!isLoadingComplete), tap(value => this.log('USERLOAD', value))),
        ]).pipe(tap(items => this.log('USERAUTHEMIT', items)), map(items => items[0])); //, shareReplay({ bufferSize: 1, refCount:  }));
        combineLatest([
            this.authService.user.pipe(tap(v => this.log('UserInfo emitted', v))),
            // this.web.waitFor('Citadel.Auth.User'),
            this.authService.isAuthenticated.pipe(tap(isAuthorized => this.log('AUTH', 'UserService', 'isAuthorized', isAuthorized)), filter$1(auth => !!auth)),
        ])
            .pipe(map(results => {
            return results[0];
        }))
            .pipe(filter$1(response => !!response))
            // .pipe(filter(response => !!response.userData && Array.isArray(response.allUserData) && response.allUserData.length > 0))
            .pipe(map(response => {
            response.sub = response['citadel-userinfo'] || response['http://schemas.citadel.co.za/scopes/claims/userinfo'] || response.sub;
            const result = {
                sub: response['citadel-userinfo'] || response['http://schemas.citadel.co.za/scopes/claims/userinfo'] || response.sub,
                impersonatorID: response['citadel-impersonator-id'] || response['http://schemas.citadel.co.za/scopes/claims/impersonator-id'],
                impersonatorName: response['citadel-impersonator-name'] || response['http://schemas.citadel.co.za/scopes/claims/impersonator-name'],
                impersonatorUserName: response['citadel-impersonator-username'] || response['http://schemas.citadel.co.za/scopes/claims/impersonator-username'],
            };
            return result;
        }))
            .pipe(distinctUntilKeyChanged('sub'))
            .pipe(tap(_ => this.fields.subjects.isLoadingComplete.next(false)))
            .pipe(mergeMap((userData) => {
            return this.userLoader.loadCurrentUser().pipe(map(user => ({ user: user, ...userData })));
        }))
            .pipe(map(response => {
            const result = new AuthUser(response.user);
            result.loadImpersonator(response);
            return result;
        }))
            .subscribe(user => {
            this.fields.subjects.user.next(user);
            this.fields.subjects.isLoadingComplete.next(true);
        });
    }
    get isAuthenticated() {
        return this.authService.isAuthenticated;
    }
    get() {
        return this.fields.observables.user;
    }
    setPauser(pauser) {
        this.fields.pauser = pauser;
        this.createUserObservable();
    }
    sendOtp(type, name, userName) {
        return this.web.get(`Citadel.Auth.User/sendloginotp/${type}/${name}/${userName}`);
    }
    changePassword(emailAddress, password, otp) {
        return this.web.post(`Citadel.Auth.User/changepassword`, { email: emailAddress, password: password, otp: otp });
    }
    log(...values) {
        if (this.diagnostic.loggingOptions.authentication) {
            console.log(...values);
        }
    }
    error(...values) {
        if (this.diagnostic.loggingOptions.authentication) {
            console.error(...values);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelUserService, deps: [{ token: CitadelAuthService }, { token: CitadelWebService }, { token: CitadelDiagnosticsService }, { token: CitadelUserInfoLoaderService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelUserService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelUserService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: CitadelAuthService }, { type: CitadelWebService }, { type: CitadelDiagnosticsService }, { type: CitadelUserInfoLoaderService }] });

class CitadelJsonInterceptor {
    intercept(req, next) {
        if (!req.headers.has('Content-Type')) {
            req = req.clone({
                headers: req.headers.set('Content-Type', 'application/json')
            });
        }
        return next.handle(req);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelJsonInterceptor, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelJsonInterceptor }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelJsonInterceptor, decorators: [{
            type: Injectable
        }] });

class CitadelLoggerInterceptor {
    constructor(diag) {
        this.diag = diag;
    }
    intercept(req, next) {
        if (!this.diag.loggingOptions.http) {
            return next.handle(req);
        }
        else {
            const started = Date.now();
            let outcome;
            return next.handle(req).pipe(tap({
                next: (event) => outcome = event instanceof HttpResponse ? 'succeeded' : '',
                error: (error) => outcome = `failed with ${error.status} ${error.statusText}: ${error.message}`
            }), 
            // Log when response observable either completes or errors
            finalize(() => {
                const elapsed = Date.now() - started;
                const msg = `${req.method} "${req.urlWithParams}" ${outcome} in ${elapsed} ms.`;
                console.log(msg);
            }));
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelLoggerInterceptor, deps: [{ token: CitadelDiagnosticsService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelLoggerInterceptor }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelLoggerInterceptor, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: CitadelDiagnosticsService }] });

class DecoratorUtils {
    wrapProperty(target, propertyName, newGetter, newSetter) {
        let currentDescriptor = Object.getOwnPropertyDescriptor(target, propertyName);
        if (!currentDescriptor) {
            currentDescriptor = Object.getOwnPropertyDescriptor(target['__proto__'], propertyName);
        }
        let privateField;
        const currentGetter = currentDescriptor ? currentDescriptor.get : () => privateField;
        const currentSetter = currentDescriptor ? currentDescriptor.set : (newValue) => privateField = newValue;
        const currentEnumerable = currentDescriptor ? currentDescriptor.enumerable : true;
        const currentConfigurable = currentDescriptor ? currentDescriptor.configurable : true;
        const getter = () => newGetter(currentGetter);
        const setter = newValue => newSetter(newValue, currentSetter);
        return Object.defineProperty(target, propertyName, {
            get: getter,
            set: setter,
            enumerable: currentEnumerable,
            configurable: currentConfigurable,
        });
    }
}

JSON['stringifyCircular'] = function (obj, replacer, indent) {
    const cache = {};
    function circularReplacer(key, value) {
        if (!!value && typeof value === 'object') {
            if (cache.hasOwnProperty(key)) {
                const name = value.constructor?.name || `object`;
                return `[${name}]`;
            }
            else {
                cache[key] = value;
            }
        }
        if (typeof replacer === 'function') {
            value = replacer(key, value);
        }
        return value;
    }
    return JSON.stringify(obj, circularReplacer, indent);
};
function logMethod(target, propertyName, propertyDescriptor) {
    if (isDevMode()) {
        const method = propertyDescriptor.value;
        propertyDescriptor.value = function (...args) {
            const params = args.map((a) => JSON['stringifyCircular'](a)).join();
            const className = target ? target.constructor.name : '<Unknown>';
            const tagName = `${className}.${propertyName}(${params})`;
            console.groupCollapsed(tagName);
            console.time(tagName);
            const result = method.apply(this, args);
            console.timeEnd(tagName);
            const resultJson = JSON['stringifyCircular'](result);
            console.log(`Call: ${tagName} => ${resultJson}`);
            console.groupEnd();
            return result;
        };
    }
    return propertyDescriptor;
}
// eslint-disable-next-line @typescript-eslint/ban-types
function logProperty(target, propertyName) {
    if (!isDevMode()) {
        return;
    }
    const className = target ? target.constructor.name : '<Unknown>';
    const tagName = `${className}.${propertyName}`;
    const utils = new DecoratorUtils();
    return utils.wrapProperty(target, propertyName, (oldGetter) => {
        const result = oldGetter();
        console.log(`Get: ${tagName} => ${result}`);
        return result;
    }, (newValue, oldSetter) => {
        console.log(`Set: ${tagName} => ${newValue}`);
        oldSetter(newValue);
    });
}
// eslint-disable-next-line @typescript-eslint/ban-types
function logParameter(target, propertyName, index) {
    if (!isDevMode()) {
        return;
    }
    // let existingRequiredParameters: number[] = Reflect.getOwnMetadata(requiredMetadataKey, target, propertyKey) || [];
    // existingRequiredParameters.push(parameterIndex);
    // Reflect.defineMetadata( requiredMetadataKey, existingRequiredParameters, target, propertyKey);
    const metadataKey = `log_${propertyName}_parameters`;
    if (Array.isArray(target[metadataKey])) {
        target[metadataKey].push(index);
    }
    else {
        target[metadataKey] = [index];
    }
}
// eslint-disable-next-line @typescript-eslint/ban-types
function logClass(target) {
    if (isDevMode()) {
        console.log(`Creating ${target.name}`);
    }
    else {
        console.error(`Remember to remove the @Log decorator from ${target.name}`);
    }
}
function Log() {
    return function (...args) {
        switch (args.length) {
            case 3: // can be method or parameter decorator
                if (typeof args[2] === 'number') {
                    // if 3rd argument is number then its index so its parameter decorator
                    return logParameter.apply(this, args);
                }
                else if (typeof args[2] === 'undefined') {
                    // if 3rd argument is number then its index so its parameter decorator
                    return logProperty.apply(this, args);
                }
                else {
                    return logMethod.apply(this, args);
                }
            case 2: // property decorator
                return logProperty.apply(this, args);
            case 1: // class decorator
                return logClass.apply(this, args);
            default:
                // invalid size of arguments
                throw new Error('Not a valid decorator');
        }
    };
}

function DeprecatedMethod(message) {
    return (target, propertyName, propertyDescriptor) => {
        if (isDevMode()) {
            const method = propertyDescriptor.value;
            propertyDescriptor.value = function (...args) {
                const className = target ? target.constructor.name : '<Unknown>';
                const tagName = `${className}.${propertyName}`;
                console.error(`${tagName} is deprecated. ${message}`);
                const result = method.apply(this, args);
                return result;
            };
        }
        return propertyDescriptor;
    };
}
function DeprecatedProperty(message) {
    return (target, propertyName) => {
        if (!isDevMode()) {
            return;
        }
        const className = target ? target.constructor.name : '<Unknown>';
        const tagName = `${className}.${propertyName}`;
        const utils = new DecoratorUtils();
        return utils.wrapProperty(target, propertyName, (oldGetter) => {
            console.error(`${tagName} is deprecated. ${message}`);
            return oldGetter();
        }, (newValue, oldSetter) => {
            console.error(`${tagName} is deprecated. ${message}`);
            oldSetter(newValue);
        });
    };
}
function DeprecatedParameter(message) {
    return (target, propertyName, index) => {
        if (!isDevMode()) {
            return;
        }
        const className = target ? target.constructor.name : '<Unknown>';
        const tagName = `${className}.${propertyName}`;
        console.error(`Parameter ${index} from ${tagName} is deprecated. ${message}`);
    };
}
function DeprecatedClass(message) {
    // eslint-disable-next-line @typescript-eslint/ban-types
    return (target) => {
        if (isDevMode()) {
            console.error(`${target.name} is deprecated. ${message}`);
        }
    };
}
function Deprecated(message) {
    return (...args) => {
        if (args.length > 2) {
            if (typeof args[2] === "number") { // if 3rd argument is number then its index so its parameter decorator
                return DeprecatedParameter(message).apply(this, args);
            }
            else if (args[2] && typeof args[2].value === 'function') { // Function
                return DeprecatedMethod(message).apply(this, args);
            }
            else {
                return DeprecatedProperty(message).apply(this, args);
            }
        }
        else if (args.length === 1) {
            return DeprecatedClass(message).apply(this, args);
        }
        else {
            throw new Error('Not a valid decorator');
        }
    };
}

class CitadelAuthenticatedUserGuard {
    constructor(router, auth, errorLogging) {
        this.router = router;
        this.auth = auth;
        this.errorLogging = errorLogging;
    }
    canActivate(_route, state) {
        return this.auth.isAuthenticated.pipe(
        // tap(isAuthorized => console.log('AUTHGUARD', 'isAuthorized', isAuthorized)),
        take$1(1), mergeMap(isAuthorized => {
            // console.log('AUTHGUARD', '_route', _route.url);
            if (isAuthorized) {
                // console.log('AUTHGUARD', 'return true');
                return of(true);
            }
            else if (state.url.toString() === '/testing') {
                // console.log('AUTHGUARD', 'return true for testing');
                return of(true);
            }
            else {
                this.auth.storeActiveRoute();
                // console.log('AUTHGUARD', 'navigate to /unauthorized');
                return this.errorLogging.sendMessagesToWebService().pipe(mergeMap(() => from(this.router.navigateByUrl('/unauthorized', { state: { unauthorized: true } }))), 
                // tap(value => console.log('AUTHGUARD', 'Done navigating to /unauthorized', value)),
                catchError(error => {
                    console.error('AUTHGUARD', 'Error navigating to /unauthorized', error);
                    throw new Error(error);
                }));
            }
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelAuthenticatedUserGuard, deps: [{ token: i1$1.Router }, { token: CitadelAuthService }, { token: CitadelErrorLoggingService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelAuthenticatedUserGuard, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelAuthenticatedUserGuard, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: i1$1.Router }, { type: CitadelAuthService }, { type: CitadelErrorLoggingService }] });

var lkpAuthMenuItemRule;
(function (lkpAuthMenuItemRule) {
    lkpAuthMenuItemRule[lkpAuthMenuItemRule["requireClient"] = 0] = "requireClient";
    lkpAuthMenuItemRule[lkpAuthMenuItemRule["requireIndividual"] = 1] = "requireIndividual";
    lkpAuthMenuItemRule[lkpAuthMenuItemRule["requireLegalEntity"] = 2] = "requireLegalEntity";
    lkpAuthMenuItemRule[lkpAuthMenuItemRule["allowUnauthenticated"] = 3] = "allowUnauthenticated";
})(lkpAuthMenuItemRule || (lkpAuthMenuItemRule = {}));
class CitadelMenuItemRule {
}
class CitadelMenuItemRules {
}

class CitadelMenuService {
    constructor(web) {
        this.web = web;
        this.fields = {
            subjects: {
                menu: null,
                menuClose: null,
            },
            observables: {
                menu: null,
                menuClose: null,
            },
            fullMenu: [],
            transformations: {
                filterCounter: 0,
                filterFuncs: {},
                mapCounter: 0,
                mapFuncs: {},
            }
        };
        this.fields.subjects.menu = new ReplaySubject(1);
        this.fields.observables.menu = this.fields.subjects.menu.asObservable();
        this.fields.subjects.menuClose = new Subject();
        this.fields.observables.menuClose = this.fields.subjects.menuClose.asObservable();
    }
    loadMenuFromStructure(items) {
        this.fields.fullMenu = /*this.buildMenuLevels(*/ this.convertItemRules(items); //); // May need to be reconsidered for Citazen, but SCP doesn't use more than two levels
        this.emitMenu();
    }
    loadMenus(appId) {
        this.web.get('Citadel.Menu', appId)
            .pipe(map((items) => this.convertItemRules(items)))
            // .pipe(map((items: CitadelMenuItem[]) => this.buildMenuLevels(items))) // May need to be reconsidered for Citazen, but SCP doesn't use more than two levels
            .subscribe((result) => {
            this.fields.fullMenu = result;
            this.emitMenu();
        });
        return this.fields.observables.menu;
    }
    refresh() {
        this.emitMenu();
    }
    buildMenuLevels(items) {
        for (let i = 0; i < items.length; i++) {
            const item = items[i];
            const depth = this.calculateDepth(item);
            const result = this.createNeededLevels(item, depth);
            items[i] = result;
        }
        return items;
    }
    convertItemRules(items) {
        for (const item of items) {
            if (!item.rules) {
                item.rules = {};
            }
            else if (Array.isArray(item.rules)) {
                item.rules = item.rules.reduce((obj, rule) => {
                    obj[lkpAuthMenuItemRule[rule.menuItemRule]] = true;
                    return obj;
                }, {});
            }
            if (item.children) {
                this.convertItemRules(item.children);
            }
        }
        return items;
    }
    createNeededLevels(input, depth) {
        if (depth >= 4 || depth <= 1 || !input.children || !input.children.length) {
            return input;
        }
        if (depth >= 2) {
            const parentItem = this.insertGroupLevels(input);
            return parentItem;
        }
    }
    insertGroupLevels(input) {
        const parentItem = JSON.parse(JSON.stringify(input));
        const items = parentItem.children;
        for (const item of items) {
            const { countGroups, itemsPerGroup } = this.calculateGroupSettings(item);
            const groups = [];
            let start = 0;
            for (let i = 0; i < countGroups; i++) {
                const newChild = { title: '', icon: 'check-circle', children: item.children.slice(start, start + itemsPerGroup), path: '' };
                groups.push(newChild);
                start += itemsPerGroup;
            }
            item.children = groups;
        }
        return parentItem;
    }
    calculateGroupSettings(item) {
        const totalItems = item.children.length;
        let countGroups = totalItems < 5 ? 1 : (totalItems <= 6 ? 2 : 3);
        let itemsPerGroup = Math.ceil(totalItems / countGroups);
        if (countGroups > 1 && itemsPerGroup * (countGroups - 1) === totalItems - 1) {
            countGroups--;
            itemsPerGroup++;
        }
        return { countGroups, itemsPerGroup };
    }
    calculateDepth(menuItem) {
        if (Array.isArray(menuItem)) {
            if (menuItem.length > 0) {
                menuItem = menuItem[0];
            }
            else {
                return 0;
            }
        }
        if (!menuItem) {
            return 0;
        }
        else if (!menuItem.children || !menuItem.children.length) {
            return 1;
        }
        else {
            return 1 + this.calculateDepth(menuItem.children[0]);
        }
    }
    emitMenu() {
        const newTree = JSON.parse(JSON.stringify(this.fields.fullMenu));
        const finalTree = this.applyTransformations(newTree);
        this.fields.subjects.menu.next(finalTree);
    }
    applyTransformations(newTree) {
        if (!newTree.length) {
            return newTree;
        }
        for (const item of newTree) {
            if (item.children && item.children.length > 0) {
                item.children = this.applyTransformations(item.children);
            }
        }
        let result = this.applyTransformationArray(newTree, this.fields.transformations.mapFuncs, (result, mapFunc) => result.map(mapFunc));
        if (!this.hasPath(result)) {
            return result;
        }
        result = this.applyTransformationArray(result, this.fields.transformations.filterFuncs, (result, filterFunc) => result.filter(filterFunc));
        return result;
    }
    hasPath(tree) {
        const hasPath = tree.findIndex(item => !!item.path) >= 0;
        return hasPath;
        // if (hasPath) {
        //   return true;
        // }
        // else {
        //   for (const item of tree) {
        //     if (item.children && this.hasPath(item.children)) {
        //       return true;
        //     }
        //   }
        // }
        // return false;
    }
    applyTransformationArray(list, functions, transform) {
        let result = list;
        for (const funcName in functions) {
            if (functions.hasOwnProperty(funcName)) {
                const func = functions[funcName];
                if (typeof func === 'function') {
                    result = transform(result, func);
                }
            }
        }
        return result;
    }
    getMenu() {
        return this.fields.observables.menu;
    }
    addFilter(func) {
        const result = ++this.fields.transformations.filterCounter;
        this.fields.transformations.filterFuncs[result] = func;
        this.emitMenu();
        return result;
    }
    removeFilter(id) {
        this.fields.transformations.filterFuncs[id] = undefined;
    }
    clearFilter() {
        this.fields.transformations.filterFuncs = {};
        this.emitMenu();
    }
    addMap(func) {
        const result = ++this.fields.transformations.mapCounter;
        this.fields.transformations.mapFuncs[result] = func;
        this.emitMenu();
        return result;
    }
    removeMap(id) {
        this.fields.transformations.mapFuncs[id] = undefined;
    }
    clearMap() {
        this.fields.transformations.mapFuncs = {};
        this.emitMenu();
    }
    closeMenu() {
        this.fields.subjects.menuClose.next();
    }
    getMenuClosed() {
        return this.fields.observables.menuClose;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelMenuService, deps: [{ token: CitadelWebService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelMenuService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelMenuService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: CitadelWebService }] });

var lkpGender;
(function (lkpGender) {
    lkpGender[lkpGender["Unknown"] = 1] = "Unknown";
    lkpGender[lkpGender["NotApplicable"] = 2] = "NotApplicable";
    lkpGender[lkpGender["Male"] = 3] = "Male";
    lkpGender[lkpGender["Female"] = 4] = "Female";
})(lkpGender || (lkpGender = {}));
var lkpPartyType;
(function (lkpPartyType) {
    lkpPartyType[lkpPartyType["NaturalPerson"] = 1] = "NaturalPerson";
    lkpPartyType[lkpPartyType["LegalEntity"] = 2] = "LegalEntity";
})(lkpPartyType || (lkpPartyType = {}));
var lkpClientBlockStatus;
(function (lkpClientBlockStatus) {
    lkpClientBlockStatus[lkpClientBlockStatus["Unblock"] = 1] = "Unblock";
    lkpClientBlockStatus[lkpClientBlockStatus["NoContactAllowed"] = 2] = "NoContactAllowed";
    lkpClientBlockStatus[lkpClientBlockStatus["NoTransactionsAllowed"] = 3] = "NoTransactionsAllowed";
    lkpClientBlockStatus[lkpClientBlockStatus["BlockAll"] = 4] = "BlockAll";
    lkpClientBlockStatus[lkpClientBlockStatus["Caution"] = 5] = "Caution";
    lkpClientBlockStatus[lkpClientBlockStatus["RelationshipProhibited"] = 6] = "RelationshipProhibited";
    lkpClientBlockStatus[lkpClientBlockStatus["DormantClient"] = 7] = "DormantClient";
})(lkpClientBlockStatus || (lkpClientBlockStatus = {}));

var RouteFixedTargets;
(function (RouteFixedTargets) {
    RouteFixedTargets[RouteFixedTargets["Stay"] = 1] = "Stay";
    RouteFixedTargets[RouteFixedTargets["Root"] = 2] = "Root";
    RouteFixedTargets[RouteFixedTargets["Parent"] = 3] = "Parent";
    RouteFixedTargets[RouteFixedTargets["Previous"] = 4] = "Previous";
    RouteFixedTargets[RouteFixedTargets["Next"] = 5] = "Next";
})(RouteFixedTargets || (RouteFixedTargets = {}));
class ActiveRouteInformation {
    constructor(routerStateSnapshot, snapshot, resolveEnd) {
        this.routerStateSnapshot = routerStateSnapshot;
        this.snapshot = snapshot;
        this.resolveEnd = resolveEnd;
        this.routeParams = this.snapshot.params;
        this.queryParams = this.snapshot.queryParams;
        this.data = this.createRouteData(this.snapshot.data);
        this.header = this.createFullPath(this.snapshot, snapshot => snapshot.data?.['header']);
        this.subheader = this.snapshot.data?.['subheader'];
        this.keepControlsInline = !!this.snapshot.data?.['keepControlsInline'];
        this.showHeader = (this.snapshot.data?.['showHeader'] === undefined || (this.snapshot.data?.['showHeader'] === 'big' ? 'big' : !!this.snapshot.data?.['showHeader']));
        this.showBack = !!this.snapshot.data?.['showBack'];
        this.showBreadcrumb = !!this.snapshot.data?.['showBreadcrumb'] || this.snapshot.data?.['showBreadcrumb'] === undefined;
        this.breadcrumbs = this.createFullPath(this.snapshot, snapshot => (snapshot.data?.['breadcrumb']) ? {
            label: snapshot.data?.['breadcrumb'],
            url: this.createUrlFromSnapshot(snapshot),
        } : undefined);
        this.colorSchemeMerged = this.createFullPath(this.snapshot, snapshot => snapshot.data?.colorScheme || {})
            .reduce((previous, current) => ({ ...previous, ...current }), {});
        this.url = this.routerStateSnapshot.url;
        this.urlFromConfig = this.getPath(this.resolveEnd.state.root);
        this.state = this.routerStateSnapshot;
    }
    createUrlFromSnapshot(snapshot) {
        const url = this.createFullPath(snapshot, snapshot => snapshot.url.toString()).filter(segment => !!segment).join('/');
        if (url.startsWith('/')) {
            return url;
        }
        else {
            return `/${url}`;
        }
    }
    getMostRelevantValue(name) {
        const result = this.createFullPath(this.snapshot, snapshot => snapshot.data?.[name])
            .filter(item => !!item);
        return result[result.length - 1];
    }
    createRouteData(data) {
        data = { ...(data || {}) };
        if (!data || Object.keys(data).length === 0) {
            data = {};
        }
        const result = data;
        result.closeTarget = result.closeTarget || RouteFixedTargets.Parent;
        result.clientChangeTarget = result.clientChangeTarget || RouteFixedTargets.Stay;
        return result;
    }
    getPath(snapshot) {
        let config;
        if (snapshot instanceof ActivatedRouteSnapshot) {
            config = snapshot.routeConfig;
        }
        else {
            config = snapshot;
        }
        let result = '';
        if (config && config.path) {
            result = config.path;
        }
        if (snapshot.children) {
            result = Location.joinWithSlash(result, snapshot.children.reduce((prev, current) => Location.joinWithSlash(prev, this.getPath(current)), ''));
        }
        return result;
    }
    createFullPath(snapshot, getValue) {
        if (!snapshot || !getValue) {
            return [];
        }
        const result = this.createFullPath(snapshot.parent, getValue);
        const value = getValue(snapshot);
        if (!!value && !result.includes(value)) {
            result.push(value);
        }
        return result;
    }
}

class CitadelNavigationService {
    constructor(router, location, route) {
        this.router = router;
        this.location = location;
        this.route = route;
        this.fields = {
            subjects: {
                activationEnd: new Subject(),
                resolveEnd: new Subject(),
                routeInfo: new ReplaySubject(1),
                busy: new BehaviorSubject(false),
            },
            observables: {
                activationEnd: null,
                resolveEnd: null,
                routeInfo: null,
                busy: null,
            },
            values: {
                routeInfo: null,
                client: null,
                isImperativeNavigation: true,
            }
        };
        this.fields.observables.routeInfo = this.fields.subjects.routeInfo.asObservable();
        this.fields.observables.busy = this.fields.subjects.busy.asObservable();
        this.fields.observables.activationEnd = this.fields.subjects.activationEnd.asObservable();
        this.fields.observables.resolveEnd = this.fields.subjects.resolveEnd.asObservable();
        router.events
            .pipe(tap(event => {
            if (event instanceof NavigationStart) {
                this.fields.subjects.busy.next(true);
                this.fields.values.isImperativeNavigation = event.navigationTrigger === 'imperative';
            }
            else if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
                this.fields.subjects.busy.next(false);
            }
        }))
            .pipe(filter$1(event => event instanceof ResolveEnd || event instanceof ActivationEnd))
            .subscribe(event => {
            if (event instanceof ResolveEnd) {
                this.fields.subjects.resolveEnd.next(event);
            }
            else if (event instanceof ActivationEnd) {
                this.fields.subjects.activationEnd.next(event);
            }
        });
        zip([
            this.fields.observables.activationEnd.pipe(filter$1((event) => !event.snapshot.firstChild)),
            this.fields.observables.resolveEnd,
        ])
            .pipe(map(arr => ({ activationEnd: arr[0], resolveEnd: arr[1] })))
            .pipe(map(events => new ActiveRouteInformation(this.router.routerState.snapshot, events.activationEnd.snapshot, events.resolveEnd))) // Map to our custom object
            .subscribe(routeInfo => {
            // console.log('NAV', routeInfo.url, routeInfo.urlFromConfig);
            this.fields.values.client = null;
            this.fields.values.routeInfo = routeInfo;
            this.fields.subjects.routeInfo.next(routeInfo);
        });
    }
    get client() {
        return this.fields.values.client;
    }
    get busy() {
        return this.fields.observables.busy;
    }
    get routeInfo() {
        return this.fields.values.routeInfo;
    }
    getRouteInfo() {
        return this.fields.observables.routeInfo;
    }
    goto(target) {
        if (typeof target === 'string') {
            const navExtras = {};
            if (this.routeInfo && (target.includes('..') || target.includes('.'))) {
                navExtras['relativeTo'] = this.route;
            }
            this.router.navigateByUrl(target, navExtras);
        }
        else if (Array.isArray(target)) {
            const navExtras = {};
            if (this.routeInfo && (target.includes('..') || target.includes('.'))) {
                navExtras['relativeTo'] = this.route;
            }
            this.router.navigate(target, navExtras);
        }
        else if (target === RouteFixedTargets.Root) {
            this.router.navigateByUrl('/');
        }
        else if (target === RouteFixedTargets.Parent) {
            this.navigateToParent();
        }
        else if (target === RouteFixedTargets.Stay) {
            // Do nothing
        }
        else if (target === RouteFixedTargets.Previous) {
            this.location.back();
        }
        else if (target === RouteFixedTargets.Next) {
            this.location.forward();
        }
    }
    close(routeInfo) {
        routeInfo = routeInfo || this.routeInfo;
        if (!routeInfo) {
            throw Error('No route specified');
        }
        this.goto(routeInfo.data.closeTarget);
    }
    handleClientChange() {
        const routeInfo = this.routeInfo;
        if (!routeInfo) {
            throw Error('No route specified');
        }
        if (this.fields.values.isImperativeNavigation) {
            this.goto(routeInfo.data.clientChangeTarget);
        }
    }
    openInNewTab(url) {
        window.open(url || '/');
    }
    setRouteClient(client) {
        this.fields.values.client = client;
        if (!this.fields.values.isImperativeNavigation || this.routeInfo && this.routeInfo.data && this.routeInfo.data.clientChangeTarget !== RouteFixedTargets.Stay) {
            return;
        }
        this.getRouteInfo().pipe(first()).subscribe(info => {
            const currentQueryParametes = { ...info.queryParams };
            const currentState = { ...this.location.getState() };
            const path = info.snapshot.pathFromRoot.reduce((prev, current) => {
                if (current && current.routeConfig && current.routeConfig.path) {
                    return `${prev}${this.buildPathWithParameters(current.routeConfig.path, current.params, client)}`;
                }
                else {
                    return prev;
                }
            }, '');
            const query = this.getQueryParameterString(currentQueryParametes, client);
            const state = Object.keys(currentState).reduce((prev, current) => {
                const result = { ...prev };
                result[current] = this.getParameterValue(current, client, currentState);
                return result;
            }, {});
            // if (typeof state['navigationId'] === 'number') {
            //   state['navigationId'] = state['navigationId']++;
            // }
            // this.location.go(path, query, state);
            this.router.navigateByUrl(path + (query ? `?${query}` : ''), { state });
        });
    }
    getCurrentNavigationState() {
        const nav = this.router.getCurrentNavigation();
        if (nav && nav.extras && nav.extras.state) {
            return nav.extras.state;
        }
        else {
            return {};
        }
    }
    getQueryParameterString(parameters, client) {
        return Object.keys(parameters).reduce((prev, current) => {
            return prev + (prev ? '&' : '') + `${current}=${this.getParameterValue(current, client, parameters)}`;
        }, '');
    }
    buildPathWithParameters(path, params, client) {
        const pathParts = path.split('/');
        const result = pathParts.reduce((prev, current) => {
            if (!current) {
                return prev;
            }
            else {
                let partValue = current;
                if (current.startsWith(':')) { // Is a parameter
                    const paramName = current.substr(1);
                    partValue = this.getParameterValue(paramName, client, params);
                }
                return `${prev}/${partValue}`;
            }
        }, '');
        return result;
    }
    getParameterValue(paramName, client, params) {
        if (!client) {
            return params[paramName];
        }
        else if (paramName.localeCompare('clientID', undefined, { sensitivity: 'base' }) === 0) {
            return client.id;
        }
        else if (paramName.localeCompare('clientName', undefined, { sensitivity: 'base' }) === 0) {
            return client.displayName;
        }
        else {
            return client[paramName] || params[paramName];
        }
    }
    navigateToParent() {
        let upNavigationCount = 0;
        let url = this.location.path(true);
        if (this.routeInfo) {
            let route = this.routeInfo.snapshot;
            let parent = route.parent;
            while (route && parent) {
                upNavigationCount++;
                if (upNavigationCount > 10) {
                    throw new Error('Too many nested route levels. Check that your route configuration is hierarchial.');
                }
                if (!route.routeConfig.path) {
                    route = parent;
                    parent = parent.parent;
                    continue;
                }
                route = parent;
                if (route.routeConfig && route.routeConfig.path) {
                    break;
                }
                if (parent) {
                    parent = parent.parent;
                }
            }
            url = this.buildPathFromParts(route.pathFromRoot, route);
            let query = this.getQueryParameterString(this.routeInfo.snapshot.queryParams, this.client);
            if (query) {
                query = `?${query}`;
            }
            return this.router.navigateByUrl(`${url}${query}`);
        }
        else {
            throw new Error('Invalid routeInfo object.');
        }
    }
    buildPathFromParts(parts, route) {
        return parts.reduce((prev, current) => {
            if (!current || !current.routeConfig || !current.routeConfig.path) {
                return prev;
            }
            else {
                const path = current.routeConfig.path;
                const parts = path.split('/');
                const newPathParts = parts.map(part => {
                    if (part.startsWith(':')) {
                        const paramName = part.substr(1);
                        const paramValue = this.getParameterValue(paramName, this.client, route.params);
                        if (paramValue) {
                            return paramValue;
                        }
                        else {
                            return part;
                        }
                    }
                    else {
                        return part;
                    }
                }).filter(value => !!value);
                const newPath = newPathParts.join('/');
                return `${prev}/${newPath}`;
            }
        }, '');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelNavigationService, deps: [{ token: i1$1.Router }, { token: i2.Location }, { token: i1$1.ActivatedRoute }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelNavigationService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelNavigationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: i1$1.Router }, { type: i2.Location }, { type: i1$1.ActivatedRoute }] });

class CitadelRecentClientsService {
    constructor(web) {
        this.web = web;
    }
    addNewClient(clientID) {
        return this.web.put(`crm.Party/AccessHistory/${clientID}`, null, { hideErrorMessage: true, noLoader: true });
    }
    getRecentClientList() {
        return this.web.get('crm.Party/AccessHistory', undefined, { hideErrorMessage: true, noLoader: true });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelRecentClientsService, deps: [{ token: CitadelWebService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelRecentClientsService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelRecentClientsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: CitadelWebService }] });
class CitadelBlankRecentClientsService {
    constructor(web) {
        this.web = web;
    }
    addNewClient(_clientID) {
        return of(0);
    }
    getRecentClientList() {
        return of([]);
    }
}

class CitadelClientInfoLoaderService {
    constructor(web) {
        this.web = web;
    }
    loadClient(id) {
        return this.web.post('Tyrus.Entity.Search', { words: [id], includeDeleted: false, maxRows: 1, applySharing: false }, { noLoader: true })
            .pipe(map$1(a => a[0]));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelClientInfoLoaderService, deps: [{ token: CitadelWebService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelClientInfoLoaderService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelClientInfoLoaderService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: CitadelWebService }] });

class CitadelClientService {
    constructor(navigation, alert, clientLoader, recents) {
        this.navigation = navigation;
        this.alert = alert;
        this.clientLoader = clientLoader;
        this.recents = recents;
        this.fields = {
            subjects: {
                client: new ReplaySubject(1),
                busy: new ReplaySubject(1),
                setReturn: {},
            },
            observables: {
                client: undefined,
                busy: undefined,
            },
            approvers: [],
            subscriptions: {
                approvers: null,
            },
            lastApprovedClient: undefined,
        };
        this.fields.observables.busy = this.fields.subjects.busy.asObservable();
        this.fields.observables.client = combineLatest([
            this.fields.subjects.client.asObservable(),
            this.fields.observables.busy,
            this.navigation.busy,
        ])
            .pipe(filter$1((values) => !values[1] && !values[2]))
            .pipe(map((values) => values[0]))
            .pipe(distinctUntilKeyChanged('id'));
    }
    get() {
        return this.fields.observables.client;
    }
    busy() {
        return this.fields.observables.busy;
    }
    set(input) {
        if (!input) {
            console.error('Invalid client supplied:', input);
            this.alert.error('Could not load supplied client');
            return throwError({ error: 'Invalid client supplied' });
        }
        if (this.isLastApprovedClient(input)) {
            return EMPTY;
        }
        const obs = new Subject();
        if (typeof input === 'string' && this.isGuid(input)) {
            this.addToSetReturn(input, obs);
            this.loadClient(input);
            return obs.asObservable();
        }
        else {
            const client = this.normalizeClientObject(input);
            this.addToSetReturn(client.id, obs);
            this.runApproval(client);
            return obs.asObservable();
        }
    }
    addToSetReturn(id, sub) {
        const currentList = this.fields.subjects.setReturn[id] || [];
        this.fields.subjects.setReturn[id] = [...currentList, sub];
    }
    notifySetReturn(id) {
        const list = this.fields.subjects.setReturn[id];
        if (!list) {
            return;
        }
        for (const sub of list) {
            sub.next(undefined);
            sub.complete();
        }
        delete this.fields.subjects.setReturn[id];
    }
    addApprover(approver) {
        if (!this.approverExists(approver)) {
            this.fields.approvers.push(approver);
        }
    }
    insertApprover(approver) {
        if (!this.approverExists(approver)) {
            this.fields.approvers.unshift(approver);
        }
    }
    approverExists(approver) {
        return this.fields.approvers.indexOf(approver) >= 0;
    }
    loadClient(id) {
        this.fields.subjects.busy.next(true);
        return this.clientLoader.loadClient(id)
            .subscribe(client => {
            if (client) {
                // eslint-disable-next-line rxjs/no-ignored-observable
                this.set(client);
            }
            else {
                console.error(`Client ID ${id} was supplied in the URL, but could not be loaded.`);
                this.alert.error('Could not load supplied client.');
            }
        });
    }
    removeApprover(approverName) {
        const index = this.fields.approvers.findIndex(value => value.name === approverName);
        if (index === -1) {
            return;
        }
        this.fields.approvers.splice(index, 1);
    }
    runApproval(client) {
        if (this.fields.approvers.length === 0) {
            this.fields.subjects.busy.next(false);
            this.setApprovedClient(client);
        }
        else {
            if (this.fields.subscriptions.approvers) {
                this.fields.subscriptions.approvers.unsubscribe();
            }
            this.fields.subjects.busy.next(true);
            this.fields.subscriptions.approvers = combineLatest(this.fields.approvers.map(approver => approver.approve(client)))
                .subscribe(clientList => {
                const errorMessages = clientList.reduce((prev, current) => {
                    if (current && current.message) {
                        prev.push(current.message);
                    }
                    return prev;
                }, []);
                const approved = clientList.reduce((prev, current) => prev && current.approved, true);
                this.fields.subjects.busy.next(false);
                if (approved) {
                    this.setApprovedClient(client);
                }
                else if (errorMessages.length > 0) {
                    this.alert.error(errorMessages[0]);
                }
            });
        }
    }
    normalizeClientObject(input) {
        const client = this.createClientObject(input);
        this.validateClientFields(client);
        return client;
    }
    createClientObject(input) {
        const output = {
            id: input['id'],
            clientNumber: input['clientNumber'],
            displayName: input['displayName'] || input['clientName'],
            partyTypeL: input['partyTypeL'],
            partyType: input['partyType'],
            identificationNumber: input['identificationNumber'],
            isPrimaryEntity: !!input['isPrimaryEntity'],
            eMailAddress: input['eMailAddress'],
            primaryContact: input['primaryContact'],
            primaryContactID: input['primaryContactID'],
            blockStatus: input['blockStatus'],
            blockStatusL: input['blockStatusL'],
        };
        if (output.partyTypeL === lkpPartyType.NaturalPerson) {
            output.firstNames = input['firstNames'] || input['fullNames'] || input['nickname'];
            output.nickname = input['nickname'];
            output.surname = input['surname'];
            output.initials = input['initials'];
            output.title = input['title'];
            output.genderL = input['genderL'] || lkpGender.Unknown;
            output.gender = input['gender'] || lkpGender[output.genderL];
        }
        if (output.blockStatusL < 0) {
            output.blockStatusL = null;
            output.blockStatus = null;
        }
        if (!output.primaryContactID) {
            output.primaryContact = null;
        }
        if (output.genderL === lkpGender.NotApplicable) {
            output.gender = 'Not Applicable';
        }
        return output;
    }
    validateClientFields(client) {
        const isClientValid = this.isGuid(client.id) &&
            Number.isInteger(client.clientNumber) &&
            client.displayName && typeof client.displayName === 'string' &&
            client.partyTypeL >= lkpPartyType.NaturalPerson && client.partyTypeL <= lkpPartyType.LegalEntity &&
            client.partyType && typeof client.partyType === 'string' &&
            (!client.blockStatusL || client.blockStatusL && typeof client.blockStatusL === 'number') &&
            (!client.blockStatusL || client.blockStatus && typeof client.blockStatus === 'string');
        if (client.partyTypeL === lkpPartyType.NaturalPerson && !client.initials) {
            client.initials = client.firstNames.split(' ').reduce((result, current) => {
                if (!!current) {
                    return result + current.charAt(0);
                }
                else {
                    return result;
                }
            }, '');
        }
        const isIndividualValid = client.partyTypeL === lkpPartyType.LegalEntity ||
            client.firstNames && typeof client.firstNames === 'string' &&
                client.nickname && typeof client.nickname === 'string' &&
                client.surname && typeof client.surname === 'string' &&
                client.initials && typeof client.initials === 'string' &&
                client.title && typeof client.title === 'string' &&
                client.genderL >= lkpGender.Unknown && client.genderL <= lkpGender.Female &&
                client.gender && typeof client.gender === 'string';
        const isPrimaryContactValid = this.isGuid(client.primaryContactID) &&
            client.primaryContact && typeof client.primaryContact === 'string';
        if (!isClientValid || !isIndividualValid || !isPrimaryContactValid) {
            console.error('Invalid client object supplied', client);
            this.alert.error('Invalid client selected');
            throw new Error('Invalid client object supplied');
        }
    }
    isGuid(value) {
        return value && value.match(/[a-fA-F0-9\-]{32,36}/);
    }
    setApprovedClient(client) {
        const mustHandleNavigation = !!this.fields.lastApprovedClient && !this.isLastApprovedClient(client);
        this.fields.lastApprovedClient = client;
        if (mustHandleNavigation) {
            this.navigation.setRouteClient(client);
            this.navigation.handleClientChange();
        }
        this.notifySetReturn(client.id);
        this.recents.addNewClient(client.id).subscribe(() => this.fields.subjects.client.next(client));
    }
    isLastApprovedClient(client) {
        if (typeof client === 'string') {
            return this.fields.lastApprovedClient && client === this.fields.lastApprovedClient.id;
        }
        else {
            return this.fields.lastApprovedClient && client.id === this.fields.lastApprovedClient.id;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelClientService, deps: [{ token: CitadelNavigationService }, { token: CitadelNotificationService }, { token: CitadelClientInfoLoaderService }, { token: CitadelRecentClientsService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelClientService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelClientService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: CitadelNavigationService }, { type: CitadelNotificationService }, { type: CitadelClientInfoLoaderService }, { type: CitadelRecentClientsService }] });

class CitadelSearchService {
    constructor() {
        this.fields = {
            providers: [],
            termsObservable: null,
            resultSubject: new Subject(),
            searchSubject: new Subject(),
            searchBusySubject: new Subject(),
        };
        this.fields.termsObservable = this.createTermsObservable();
    }
    busy() {
        return this.fields.searchBusySubject.asObservable();
    }
    search(input) {
        if (this.fields.providers.length === 0) {
            throw new Error('No search providers are registered');
        }
        if (input && input.trim() && input.replace(/\s*/, '').length >= 3) { // Total length of search terms should be at least three characters, excluding whitespace.
            const terms = [...new Set(input.split(/[\s,;]+/))] // Only unique words (splitting on whitespace, commas and semicolons)
                .filter(value => !!value && !!value.trim()); // Strip empty terms
            this.fields.searchBusySubject.next(true);
            this.fields.searchSubject.next(terms);
        }
    }
    createTermsObservable() {
        const typingDelay = 300;
        return this.fields.searchSubject.asObservable() // Take the input...
            .pipe(debounceTime(typingDelay)) // ...only once the user stops typing for so many miliseconds...
            .pipe(distinctUntilChanged()); // ...and do nothing until the value changes 
    }
    createResultObservable() {
        const terms = this.fields.termsObservable;
        const providerArray = this.fields.providers.map(// Convert my array of providers into an array of observables containing results  
        // Convert my array of providers into an array of observables containing results  
        provider => terms.pipe(switchMap(terms => provider.execute(...terms))) // SwitchMap will cancel pending requests
            .pipe(map(value => {
            const provResults = { ...provider, results: value };
            return provResults;
        })).pipe(tap(() => this.fields.searchBusySubject.next(false))));
        return combineLatest(providerArray); // Wait for all observables to emit at least once, then emit all of them
    }
    addProvider(provider) {
        if (this.validateProvider(provider)) {
            this.fields.providers.push(provider);
        }
    }
    removeProvider(id) {
        const index = this.findProviderIndex(id);
        if (index === -1) {
            throw new Error(`The search provider ${id} could not be removed, because it is not registered`);
        }
    }
    findProviderIndex(id) {
        return this.fields.providers.findIndex(provider => provider.id === id);
    }
    validateProvider(provider) {
        if (!provider || !provider.nameSingular || !provider.namePlural || !provider.id || !provider.execute) {
            if (provider && provider.id) {
                throw new Error(`The search provider ${provider.id} could not be registered`);
            }
            else {
                throw new Error(`A search provider could not be registered`);
            }
        }
        const index = this.findProviderIndex(provider.id);
        return index === -1;
        // if (index >= 0) {
        //   throw new Error(`Cannot register the search provider ${provider.id} more than once`);
        // }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelSearchService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelSearchService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelSearchService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [] });

class ClientSharingApprover {
    constructor(web, user) {
        this.web = web;
        this.user = user;
        this.name = 'Sharing';
    }
    approve(client) {
        return this.user.get().pipe(mergeMap(user => this.web.post('Tyrus.Entity.Sharing/StaffSharing', {
            staffID: user.id,
            parties: [{ "partyID": client.id }],
            viewDate: new Date(),
            IncludeDeletedEntities: true,
        }))).pipe(map(matches => {
            return {
                approved: matches.length > 0,
                message: matches.length > 0 ? '' : 'You don\'t have permissions to see this client',
            };
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ClientSharingApprover, deps: [{ token: CitadelWebService }, { token: CitadelUserService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ClientSharingApprover, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ClientSharingApprover, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: CitadelWebService }, { type: CitadelUserService }] });

class CitadelLoaderService {
    constructor(web) {
        this.fields = {
            enabled: true,
            refCount: 0,
            subjects: {
                loader: new ReplaySubject(1),
            },
            observables: {
                showLoader: undefined,
                hideLoader: undefined,
            }
        };
        this.fields.observables.hideLoader = this.fields.subjects.loader.pipe(filter(isLoading => !isLoading));
        this.fields.observables.showLoader = this.fields.subjects.loader.pipe(filter(isLoading => !!isLoading));
        web.isBusy.subscribe(busy => {
            if (busy) {
                this.show();
            }
            else {
                this.hide();
            }
        });
    }
    show() {
        this.fields.refCount++;
        this.emit();
    }
    hide() {
        if (this.fields.refCount > 0) {
            this.fields.refCount--;
            this.emit();
        }
    }
    enable() {
        this.fields.enabled = true;
    }
    disable() {
        this.fields.enabled = false;
    }
    get show$() {
        return this.fields.observables.showLoader;
    }
    get hide$() {
        return this.fields.observables.hideLoader;
    }
    emit() {
        if (!this.fields.enabled) {
            return;
        }
        if (this.fields.refCount === 0) {
            this.fields.subjects.loader.next(false);
        }
        else if (this.fields.refCount === 1) {
            this.fields.subjects.loader.next(true);
        }
    }
    isShowing() {
        return this.fields.refCount > 0;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelLoaderService, deps: [{ token: CitadelWebService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelLoaderService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelLoaderService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: CitadelWebService }] });

class CitadelLoggerService {
    constructor(diagnostics) {
        this.diagnostics = diagnostics;
        this.fields = {
            oldConsole: {
                assert: console.assert,
                clear: console.clear,
                count: console.count,
                // countReset: console.countReset,
                debug: console.debug,
                dir: console.dir,
                dirxml: console.dirxml,
                error: console.error,
                // exception: console.exception,
                group: console.group,
                groupCollapsed: console.groupCollapsed,
                groupEnd: console.groupEnd,
                info: console.info,
                log: console.log,
                table: console.table,
                time: console.time,
                timeEnd: console.timeEnd,
                // timeLog: console.timeLog,
                timeStamp: console.timeStamp,
                trace: console.trace,
                warn: console.warn,
            }
        };
    }
    assert(condition, ...data) {
        return this.fields.oldConsole.assert(condition, ...data);
    }
    clear() {
        return this.fields.oldConsole.clear();
    }
    count(label) {
        return this.fields.oldConsole.count(label);
    }
    // countReset(label?: string): void {
    //   return this.fields.oldConsole.countReset(label);
    // }
    debug(...data) {
        return this.fields.oldConsole.debug(...data);
    }
    dir(item, options) {
        return this.fields.oldConsole.dir(item, options);
    }
    // dirxml(...data: any[]): void {
    //   return this.fields.oldConsole.dirxml(...data);
    // }
    error(...data) {
        return this.fields.oldConsole.error(...data);
    }
    // exception(message?: string, ...optionalParams: any[]): void {
    //   return this.fields.oldConsole.exception(message, ...optionalParams);
    // }
    group(...data) {
        return this.fields.oldConsole.group(...data);
    }
    groupCollapsed(...data) {
        return this.fields.oldConsole.groupCollapsed(...data);
    }
    groupEnd() {
        return this.fields.oldConsole.groupEnd();
    }
    info(...data) {
        return this.fields.oldConsole.info(...data);
    }
    log(...data) {
        return this.fields.oldConsole.log(...data);
    }
    table(tabularData, properties) {
        return this.fields.oldConsole.table(tabularData, properties);
    }
    time(label) {
        return this.fields.oldConsole.time(label);
    }
    timeEnd(label) {
        return this.fields.oldConsole.timeEnd(label);
    }
    // timeLog(label?: string, ...data: any[]): void {
    //   return this.fields.oldConsole.timeLog(label, ...data);
    // }
    timeStamp(label) {
        return this.fields.oldConsole.timeStamp(label);
    }
    trace(...data) {
        return this.fields.oldConsole.trace(...data);
    }
    warn(...data) {
        return this.fields.oldConsole.warn(...data);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelLoggerService, deps: [{ token: CitadelDiagnosticsService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelLoggerService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelLoggerService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: CitadelDiagnosticsService }] });

class CitadelDeviceInterceptor {
    constructor(device) {
        this.device = device;
    }
    intercept(req, next) {
        if (!req.headers.has('Device-Type')) {
            let deviceType = 'Desktop';
            if (this.device.isMobile()) {
                deviceType = 'Mobile';
            }
            else if (this.device.isTablet()) {
                deviceType = 'Tablet';
            }
            req = req.clone({
                headers: req.headers.set('Device-Type', deviceType)
            });
        }
        return next.handle(req);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelDeviceInterceptor, deps: [{ token: i1$2.DeviceDetectorService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelDeviceInterceptor }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelDeviceInterceptor, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i1$2.DeviceDetectorService }] });

class CitadelFormChangesService {
    constructor() {
        this.forms = {};
        this.attachBeforeUnload();
    }
    get hasDirtyForm() {
        for (const key in this.forms) {
            if (this.forms.hasOwnProperty(key)) {
                const current = this.forms[key];
                if (current && current.dirty) {
                    return true;
                }
            }
        }
        return false;
    }
    registerForm(key, form) {
        this.forms[key] = form;
    }
    deregisterForm(key) {
        delete this.forms[key];
    }
    promptToConfirmNavigation() {
        return confirm('You will lose unsaved changes if you navigate away.');
    }
    attachBeforeUnload() {
        window.addEventListener("beforeunload", e => {
            if (!this.hasDirtyForm) {
                return undefined;
            }
            const confirmationMessage = 'You will lose unsaved changes if you navigate away.';
            (e || window.event).returnValue = confirmationMessage; //Gecko + IE
            return confirmationMessage; //Gecko + Webkit, Safari, Chrome etc.
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelFormChangesService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelFormChangesService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelFormChangesService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [] });

class CitadelUnsavedFormChangesGuard {
    constructor(formChanges) {
        this.formChanges = formChanges;
    }
    canDeactivate(_component, _currentRoute, _currentState, _nextState) {
        return !this.formChanges.hasDirtyForm || this.formChanges.promptToConfirmNavigation();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelUnsavedFormChangesGuard, deps: [{ token: CitadelFormChangesService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelUnsavedFormChangesGuard, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelUnsavedFormChangesGuard, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: CitadelFormChangesService }] });

class CitadelSilentImpersonationService {
    constructor(auth, web, userService) {
        this.auth = auth;
        this.web = web;
        this.userService = userService;
    }
    GetUser(id) {
        return this.web.get(`Citadel.Auth.User/${id}`);
    }
    impersonateUser(id) {
        return this.GetUser(id)
            .pipe(mergeMap((user) => {
            if (user) {
                return of(user);
            }
            else {
                return this.web.post(`Citadel.Auth.User/CreateImpersonationContext/${id}`, undefined);
            }
        }))
            .pipe(map((user) => {
            if (user.roles.some(item => item.label === 'MSZ Client User' || item.label === 'SecureClient User')) {
                return user.id;
            }
            else {
                throw new Error('User doesn\'t have permission to access the site');
            }
        }))
            .pipe(mergeMap((userID) => this.web.post(`Citadel.Auth.User/impersonate/${userID}`, {})))
            .pipe(mergeMap(_ => this.auth.refreshSession().pipe(mergeMap(() => this.userService.get().pipe(take$1(1))))));
        // .pipe(tap(v => console.log('Started impersonation', v)));
    }
    impersonate(id) {
        this.web.post(`Citadel.Auth.User/impersonate/${id}`, {})
            .pipe(mergeMap(() => this.auth.refreshSession()))
            .subscribe(() => console.log('Started impersonation'));
    }
    cancel() {
        this.web.post(`Citadel.Auth.User/impersonate/cancel`, {})
            .pipe(mergeMap(() => this.auth.refreshSession()))
            .subscribe(() => console.log('Cancelled impersonation'));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelSilentImpersonationService, deps: [{ token: CitadelAuthService }, { token: CitadelWebService }, { token: CitadelUserService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelSilentImpersonationService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelSilentImpersonationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: CitadelAuthService }, { type: CitadelWebService }, { type: CitadelUserService }] });

class CitadelDataCache {
    constructor(fetchData, makeKey) {
        this.fetchData = fetchData;
        this.makeKey = makeKey;
        this.cache = {
            subjects: {},
            observables: {}
        };
    }
    get(...args) {
        const key = this.makeKey(args);
        return this.cache.observables[key] || this.createObservable(key, ...args);
    }
    createObservable(key, ...args) {
        this.cache.subjects[key] = new ReplaySubject(1);
        this.cache.observables[key] = this.cache.subjects[key].asObservable();
        this.fetchData(args).subscribe(this.cache.subjects[key]);
        return this.cache.observables[key];
    }
}

class CitadelDataCacheService {
    createDataCache(fetchData, makeKey = (...args) => args.toString()) {
        return new CitadelDataCache(fetchData, makeKey);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelDataCacheService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelDataCacheService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelDataCacheService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

class CitadelStringInterpolationService {
    interpolate(source, data, formatter, regex) {
        if (!source || !data || typeof source !== 'string' || typeof data !== 'object') {
            return source || '';
        }
        ({ formatter, regex } = this.provideDefaultParameters(formatter, regex));
        if (!formatter || typeof formatter !== 'function') {
            formatter = this.defaultFormatter;
        }
        if (!regex) {
            regex = /{{([\w\-_]+)(\|(time|date)+)*}}/gm;
        }
        return source.replace(regex, (match, ...groups) => {
            // console.log(match, groups);
            return formatter(data, ...groups) || match;
        });
    }
    format(input, ...args) {
        args = args
            .map((arg) => {
            if (arg instanceof Date) {
                return arg.toLocaleDateString(undefined, { dateStyle: 'medium' });
            }
            else if (typeof arg === 'object') {
                return Object.keys(arg).map((key) => {
                    const obj = arg[key];
                    if (obj instanceof Date) {
                        return obj.toLocaleDateString(undefined, {
                            dateStyle: 'medium',
                            timeStyle: 'medium',
                        });
                    }
                    else {
                        return obj;
                    }
                });
            }
            else {
                return arg;
            }
        })
            .reduce((acc, val) => acc.concat(val));
        return input.replace(/{([0-9]+)}/g, (match, index) => typeof args[index] === 'undefined' ? match : args[index]);
    }
    provideDefaultParameters(formatter, regex) {
        return {
            formatter: formatter || this.defaultFormatter,
            regex: regex || /{{([\w\-_]+)(\|(time|date)+)*}}/gm,
        };
    }
    defaultFormatter(data, ...groups) {
        const input = data[groups[0]];
        if (groups[2] === 'time' || groups[2] === 'date') {
            const inputDate = (input instanceof Date) ? input : new Date(input);
            if (groups[2] === 'time') {
                return inputDate.toLocaleTimeString('en-za', {
                    hour: 'numeric',
                    minute: 'numeric',
                });
            }
            else if (groups[2] === 'date') {
                return inputDate.toLocaleDateString('en-za', {
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                });
            }
        }
        else {
            return input.toString();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelStringInterpolationService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelStringInterpolationService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelStringInterpolationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

class RetriableError extends Error {
}
class FatalError extends Error {
}
class CitadelServerSentNotificationsService {
    constructor(_zone, auth, interpolation, diagostics, config, web) {
        this._zone = _zone;
        this.auth = auth;
        this.interpolation = interpolation;
        this.diagostics = diagostics;
        this.config = config;
        this.web = web;
        this.subjectMap = {};
        this.errorMap = {};
        this.authToken = '';
    }
    getServerSentEvents() {
        return combineLatest([this.config.getGlobalSettingsLoaded(), this.config.getConfig()])
            .pipe(map$1((arr) => ({ appSettings: arr[0], config: arr[1].wrappedObject })))
            .pipe(map$1(({ appSettings, config }) => {
            const url = config.Services['Citadel.Notification.Service']; //'https://api-citazen-notification-sse-development.azurewebsites.net'; // 'https://localhost:7204/'; //  
            let eventSub = this.subjectMap[url];
            let errorSub = this.errorMap[url];
            if (!url) {
                return {
                    event: NEVER,
                    error: NEVER,
                };
            }
            if (!eventSub) {
                eventSub = new Subject();
                this.subjectMap[url] = eventSub;
                errorSub = new Subject();
                this.errorMap[url] = errorSub;
                this.getEventSource(Location.joinWithSlash(url, 'sse'), eventSub, errorSub);
            }
            return {
                event: eventSub.asObservable().pipe(filter$1(event => event.systems.includes(appSettings.application)), tap$1(event => this.log(event))),
                error: errorSub.asObservable(),
            };
        }));
    }
    getNotifications() {
        return combineLatest([
            this.config.getGlobalSettingsLoaded().pipe(take$1(1)),
            this.web.get('PushNotifications/user')
        ]).pipe(map$1(results => {
            const appSettings = results[0];
            return results[1].filter(event => event.applicationID.toUpperCase() === appSettings.applicationID.toUpperCase());
        }), concatMap(notification => notification), map$1((notification) => {
            if (typeof notification.data === 'string') {
                notification.data = JSON.parse(notification.data);
            }
            return notification;
        }), map$1(data => this.processInterpolation(data)), toArray());
    }
    getEventSource(url, eventSub, errorSub) {
        this.auth.isAuthenticated.pipe(
        // tap(isAuthorized => console.log('AUTH', 'SSE', 'isAuthorized', isAuthorized)),
        filter$1(isAuthenticated => !!isAuthenticated), switchMap(() => this.auth.getToken()), filter$1(token => !!token), first$1()).subscribe(token => {
            fetchEventSource(url, {
                credentials: 'include',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    // 'X-Accel-Buffering': 'no',
                    // 'Cache-Control': 'no-cache',
                },
                onopen: this.eventOpen(),
                onmessage: this.eventMessage(eventSub),
                onerror: this.eventError(url, eventSub, errorSub),
                onclose: this.eventClose(),
                keepalive: true,
            });
        });
    }
    eventMessage(eventSub) {
        return event => {
            this._zone.run(() => {
                this.log('SSE Received', { event: event, isCompleted: eventSub.closed });
                if (!event.data) {
                    this.log('SSE Message empty and not emitted');
                    return;
                }
                eventSub.next(this.processInterpolation(JSON.parse(event.data)));
            });
        };
    }
    eventError(url, eventSub, errorSub) {
        return error => {
            if (error instanceof FatalError) {
                throw error;
            }
            this._zone.run(() => {
                this.error('SSE Error', { error });
                errorSub.next(error);
                setTimeout(() => this.getEventSource(url, eventSub, errorSub), 20_000);
                throw new FatalError(error.message);
            });
        };
    }
    /* eslint-disable @typescript-eslint/ban-types, no-restricted-syntax */
    eventOpen() {
        return (response) => {
            const result = new Promise((resolve) => {
                if (response.ok && response.headers.get('content-type') === 'text/event-stream') {
                    resolve(undefined); // everything's good
                }
                else if (response.status >= 400 && response.status < 500 && response.status !== 429) {
                    throw new FatalError(`Client-side error ${response.status} ${response.statusText}`);
                }
                else {
                    throw new RetriableError(`Server error ${response.status} ${response.statusText}`);
                }
            });
            this.log('SSE Open:', response);
            return result;
        };
    }
    /* eslint-enable @typescript-eslint/ban-types */
    eventClose() {
        return () => {
            this.log('SSE Close');
            throw new Error('The connection has been closed');
        };
    }
    processInterpolation(obj) {
        if (obj.data && obj.data.url) {
            obj.data['url'] = this.interpolation.interpolate(obj.data['url'], obj.data);
        }
        if (obj.data && obj.data.offlineMessage) {
            obj.data['offlineMessage'] = this.interpolation.interpolate(obj.data['offlineMessage'], obj.data);
        }
        this.addClientNameTemplate(obj);
        obj['message'] = this.interpolation.interpolate(obj['message'], obj.data);
        return obj;
    }
    addClientNameTemplate(obj) {
        const data = obj.data || {};
        const clientName = data.clientName;
        const message = obj.message || '';
        if (!clientName || !clientName.trim()) {
            return;
        }
        if (message.search(/[.\]]+\s*$/) > -1) {
            return;
        }
        if (message.indexOf('{{clientName}}') > -1) {
            return;
        }
        obj.message = `${message} for ${clientName}`;
    }
    log(...args) {
        if (this.diagostics?.loggingOptions?.sse) {
            console.log(...args);
        }
    }
    error(...args) {
        if (this.diagostics?.loggingOptions?.sse) {
            console.error(...args);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelServerSentNotificationsService, deps: [{ token: i0.NgZone }, { token: CitadelAuthService }, { token: CitadelStringInterpolationService }, { token: CitadelDiagnosticsService }, { token: CitadelConfigurationService }, { token: CitadelWebService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelServerSentNotificationsService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelServerSentNotificationsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: i0.NgZone }, { type: CitadelAuthService }, { type: CitadelStringInterpolationService }, { type: CitadelDiagnosticsService }, { type: CitadelConfigurationService }, { type: CitadelWebService }] });

function Timeout(milliseconds = 0) {
    return function (target, propertyKey, descriptor) {
        const originalMethod = descriptor.value;
        descriptor.value = function (...args) {
            setTimeout(() => {
                originalMethod.apply(this, args);
            }, milliseconds);
        };
        return descriptor;
    };
}

var paymentsDue;
(function (paymentsDue) {
    paymentsDue[paymentsDue["EndOfPeriod"] = 0] = "EndOfPeriod";
    paymentsDue[paymentsDue["BeginningOfPeriod"] = 1] = "BeginningOfPeriod";
})(paymentsDue || (paymentsDue = {}));

class CitadelCalculationsService {
    //#region Based on excel formulas
    FV(rate, nper, pmt, pv = 0, type = paymentsDue.EndOfPeriod) {
        let result = undefined;
        if (rate === 0) {
            result = pv + pmt * nper;
        }
        else {
            const term = Math.pow(1 + rate, nper);
            if (type === 1) {
                result = pv * term + (pmt * (1 + rate) * (term - 1)) / rate;
            }
            else {
                result = pv * term + (pmt * (term - 1)) / rate;
            }
        }
        return (result !== undefined) ? -result : result;
    }
    PV(rate, nper, pmt, fv = 0, type = paymentsDue.EndOfPeriod) {
        if (rate === 0) {
            return -pmt * nper - fv;
        }
        else {
            return (((1 - Math.pow(1 + rate, nper)) / rate) * pmt * (1 + rate * type) - fv) / Math.pow(1 + rate, nper);
        }
    }
    PMT(rate, nper, pv, fv = 0, type = paymentsDue.EndOfPeriod) {
        let result = undefined;
        if (rate === 0) {
            result = (pv + fv) / nper;
        }
        else {
            const term = Math.pow(1 + rate, nper);
            if (type === 1) {
                result = ((fv * rate) / (term - 1) + (pv * rate) / (1 - 1 / term)) / (1 + rate);
            }
            else {
                result = (fv * rate) / (term - 1) + (pv * rate) / (1 - 1 / term);
            }
        }
        return (result !== undefined) ? -result : result;
    }
    IPMT(rate, per, nper, pv, fv = 0, type = paymentsDue.EndOfPeriod) {
        const payment = this.PMT(rate, nper, pv, fv, type);
        let interest = 0;
        if (per === 1) {
            if (type === 1) {
                interest = 0;
            }
            else {
                interest = -pv;
            }
        }
        else {
            if (type === 1) {
                interest = this.FV(rate, per - 2, payment, pv, 1) - payment;
            }
            else {
                interest = this.FV(rate, per - 1, payment, pv, 0);
            }
        }
        return interest * rate;
    }
    PPMT(rate, per, nper, pv, fv = 0, type = paymentsDue.EndOfPeriod) {
        return this.PMT(rate, nper, pv, fv, type) - this.IPMT(rate, per, nper, pv, fv, type);
    }
    NPER(rate, pmt, pv, fv = 0, type = paymentsDue.EndOfPeriod) {
        if (rate === 0) {
            return -(pv + fv) / pmt;
        }
        else {
            const num = pmt * (1 + rate * type) - fv * rate;
            const den = pv * rate + pmt * (1 + rate * type);
            return Math.log(num / den) / Math.log(1 + rate);
        }
    }
    RATE(nper, pmt, pv, fv = 0, type = paymentsDue.EndOfPeriod, guess = 0.1) {
        const epsMax = 1e-10;
        const iterMax = 20;
        let rate = guess;
        for (let i = 0; i < iterMax; i++) {
            if (rate <= -1) {
                return new Error('#NUM!');
            }
            let y, f;
            if (Math.abs(rate) < epsMax) {
                y = pv * (1 + nper * rate) + pmt * (1 + rate * type) * nper + fv;
            }
            else {
                f = Math.pow(1 + rate, nper);
                y = pv * f + pmt * (1 / rate + type) * (f - 1) + fv;
            }
            if (Math.abs(y) < epsMax) {
                return rate;
            }
            let dy;
            if (Math.abs(rate) < epsMax) {
                dy = pv * nper + pmt * type * nper;
            }
            else {
                f = Math.pow(1 + rate, nper);
                const df = nper * Math.pow(1 + rate, nper - 1);
                dy = pv * df + pmt * (1 / rate + type) * df + pmt * (-1 / (rate * rate)) * (f - 1);
            }
            rate -= y / dy;
        }
        return rate;
    }
    NOMINAL(effect_rate, npery) {
        if (effect_rate <= 0 || npery < 1) {
            return new Error('#NUM!');
        }
        npery = parseInt(npery.toString(), 10);
        return (Math.pow(effect_rate + 1, 1 / npery) - 1) * npery;
    }
    EFFECT(nominal_rate, npery) {
        if (nominal_rate <= 0 || npery < 1) {
            return new Error('#NUM!');
        }
        npery = parseInt(npery.toString(), 10);
        return Math.pow(1 + nominal_rate / npery, npery) - 1;
    }
    //#endregion Based on excel formulas
    ResultantRate(iRate, eRate) {
        return ((1 + iRate) / (1 + eRate)) - 1;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelCalculationsService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelCalculationsService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelCalculationsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

class CitadelMaintenanceService {
    constructor(http, sse, config, interpolation) {
        this.http = http;
        this.sse = sse;
        this.config = config;
        this.interpolation = interpolation;
        this.fields = {
            mainAppName: '',
            appSettings: {
                configPath: '',
                environment: '',
            },
            config: {},
            subjects: {
                maintenanceStarting: new Subject(),
                maintenanceWarning: new Subject(),
                maintenanceDone: new ReplaySubject(1),
                maintenancePending: new ReplaySubject(1),
                maintenanceTestingStart: new ReplaySubject(1),
                maintenanceInProgress: new ReplaySubject(1),
            },
            observables: {
                maintenanceStarting: undefined,
                maintenanceWarning: undefined,
                maintenanceDone: undefined,
                maintenancePending: undefined,
                maintenanceTestingStart: undefined,
                maintenanceInProgress: undefined,
            },
            maintenance: {
                config: undefined,
                warningTimer: undefined,
                signOutTimer: undefined,
                availabilityTimer: undefined,
                inProgress: false,
            },
            intervals: {
                staticTime: 3600000,
                activeTime: 600000,
                currentIntervalID: 0,
            }
        };
        this.testEntries = [];
        this.getMaintenanceCallParameters = settings => of({
            applicationID: settings.application,
            environment: settings.environment,
        });
        this.fields.observables.maintenanceStarting = this.fields.subjects.maintenanceStarting.asObservable();
        this.fields.observables.maintenanceWarning = this.fields.subjects.maintenanceWarning.asObservable();
        this.fields.observables.maintenanceDone = this.fields.subjects.maintenanceDone.asObservable();
        this.fields.observables.maintenancePending = this.fields.subjects.maintenancePending.asObservable();
        this.fields.observables.maintenanceTestingStart = this.fields.subjects.maintenanceTestingStart.asObservable();
        this.fields.observables.maintenanceInProgress = this.fields.subjects.maintenanceInProgress.asObservable().pipe(distinctUntilChanged(), tap$1(inProgress => this.fields.maintenance.inProgress = inProgress));
        this.config.getGlobalSettingsLoaded().subscribe(settings => this.initialize(settings));
        this.sse.getServerSentEvents()
            .pipe(concatMap(obs => obs.event))
            .pipe(filter$1((event) => event.type === 'maintenance'))
            .subscribe((event) => {
            this.emitMaintenanceTestingStart(event.data['isTestingEnabled']);
            if (event.data['remove']) {
                this.emitMaintenanceDone();
            }
            else if (event.data.start && event.data.end) {
                this.fields.maintenance.config = {
                    startDate: new Date(event.data.start),
                    endDate: new Date(event.data.end),
                    offlineMessage: event.data.offlineMessage,
                    noticeMessage: event.message,
                    isTestingEnabled: event.data['isTestingEnabled'],
                };
                this.setMaintenanceTimers();
                this.emitMaintenancePending(this.fields.maintenance.config);
                // }
            }
        });
    }
    clearMaintenanceTimers() {
        clearTimeout(this.fields.maintenance.warningTimer);
        clearTimeout(this.fields.maintenance.signOutTimer);
        clearTimeout(this.fields.maintenance.availabilityTimer);
        this.emitMaintenanceInProgress(false);
    }
    setMaintenanceTimers() {
        if (!this.fields.maintenance.config) {
            return;
        }
        const now = new Date();
        const startDate = new Date(this.fields.maintenance.config.startDate);
        const endDate = new Date(this.fields.maintenance.config.endDate);
        const signOutMilliseconds = startDate.valueOf() - now.valueOf();
        const warningMilliseconds = signOutMilliseconds - (10 * 60 * 1000);
        const availabilityMilliseconds = endDate.valueOf() - now.valueOf();
        this.fields.maintenance.signOutTimer = setTimeout(() => this.emitMaintenanceStarting(), Math.max(0, signOutMilliseconds));
        this.fields.maintenance.warningTimer = setTimeout(() => this.emitMaintenanceWarning(startDate, endDate), Math.max(10, warningMilliseconds));
        this.fields.maintenance.availabilityTimer = setTimeout(() => this.emitMaintenanceDone(), Math.max(0, availabilityMilliseconds));
        if (signOutMilliseconds > 0) {
            this.emitMaintenanceInProgress(false);
        }
    }
    canUserDoTesting(user) {
        return user.hasPermission('AppConfig');
    }
    emitMaintenanceStarting() {
        this.fields.subjects.maintenanceStarting.next();
        this.fields.subjects.maintenanceInProgress.next(true);
    }
    emitMaintenanceDone() {
        this.emitMaintenancePending();
        this.fields.subjects.maintenanceDone.next();
        this.fields.subjects.maintenanceInProgress.next(false);
        this.fields.subjects.maintenanceWarning.next('');
    }
    emitMaintenanceTestingStart(enabled) {
        this.fields.subjects.maintenanceTestingStart.next(!!enabled);
    }
    emitMaintenancePending(entry) {
        this.fields.subjects.maintenancePending.next(entry);
    }
    emitMaintenanceWarning(startDate, endDate) {
        this.fields.observables.maintenanceInProgress.pipe(first$1()).subscribe((isInProgress) => {
            if (isInProgress) {
                const time = `${this.padZeros(endDate.getHours())}:${this.padZeros(endDate.getMinutes())}`;
                const message = `The site will be unavailable for maintenance until ${time}.`;
                this.fields.subjects.maintenanceWarning.next(message);
            }
            else {
                const time = `${this.padZeros(startDate.getHours())}:${this.padZeros(startDate.getMinutes())}`;
                const message = `You will be signed out at ${time} so maintenance may be performed on the site.`;
                this.fields.subjects.maintenanceWarning.next(message);
            }
        });
    }
    emitMaintenanceInProgress(value) {
        this.createInterval(value ? this.fields.intervals.activeTime : this.fields.intervals.staticTime);
        this.fields.subjects.maintenanceInProgress.next(value);
    }
    getTestingStarted() {
        return this.fields.observables.maintenanceTestingStart.pipe(tap$1(v => console.log('Testing started:', v)));
    }
    getMaintenanceInProgress() {
        return this.fields.observables.maintenanceInProgress;
    }
    getMaintenanceStarting() {
        return this.fields.observables.maintenanceStarting;
    }
    getMaintenanceWarning() {
        return this.fields.observables.maintenanceWarning;
    }
    getMaintenancePending() {
        return this.fields.observables.maintenancePending;
    }
    setMaintenance(entry) {
        this.testEntries = [entry];
    }
    initialize(settings) {
        if (settings.ignoreMaintenance) {
            return;
        }
        return this.config.getConfig().pipe(tap$1(_ => this.fields.config = settings), tap$1(config => this.setupPolling(config.get('Global:Maintenance:StaticPollingInterval') || this.fields.intervals.staticTime, config.get('Global:Maintenance:ActivePollingInterval') || this.fields.intervals.activeTime))).subscribe(_ => this.callService(settings));
    }
    setupPolling(staticInterval, activeInterval) {
        this.fields.intervals.staticTime = staticInterval;
        this.fields.intervals.activeTime = activeInterval;
    }
    createInterval(time) {
        if (this.fields.intervals.currentIntervalID !== 0) {
            clearInterval(this.fields.intervals.currentIntervalID);
        }
        this.fields.intervals.currentIntervalID = setInterval(() => this.callService(this.fields.config), time);
    }
    callService(settings) {
        return this.getMaintenanceCallParameters(settings).pipe(mergeMap(params => this.http.get(Location.joinWithSlash(settings.configPath, `Maintenance/${params.applicationID}/${params.environment}`))), map(entries => entries.map(entry => {
            entry.startDate = new Date(entry.startDate);
            entry.endDate = new Date(entry.endDate);
            entry['start'] = entry.startDate;
            entry['end'] = entry.endDate;
            entry.noticeMessage = this.interpolation.interpolate(entry.noticeMessage, entry);
            entry.offlineMessage = this.interpolation.interpolate(entry.offlineMessage, entry);
            return entry;
        })))
            .subscribe(entries => {
            this.fields.maintenance.inProgress;
            if (entries.length === 0) {
                this.fields.maintenance.config = undefined;
                if (this.fields.maintenance.inProgress) {
                    this.emitMaintenanceDone();
                }
                this.emitMaintenanceTestingStart(false);
                this.clearMaintenanceTimers();
                this.emitMaintenancePending();
            }
            else {
                this.fields.maintenance.config = entries[0];
                if (this.fields.maintenance.inProgress && (this.fields.maintenance.config.startDate > new Date() || this.fields.maintenance.config.endDate < new Date())) {
                    this.emitMaintenanceDone();
                }
                this.emitMaintenanceTestingStart(this.fields.maintenance.config.isTestingEnabled);
                this.setMaintenanceTimers();
                this.emitMaintenancePending(this.fields.maintenance.config);
            }
        });
    }
    padZeros(value) {
        let result = value.toString();
        while (result.length < 2) {
            result = '0' + result;
        }
        return result;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelMaintenanceService, deps: [{ token: i1.HttpClient }, { token: CitadelServerSentNotificationsService }, { token: CitadelConfigurationService }, { token: CitadelStringInterpolationService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelMaintenanceService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelMaintenanceService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: i1.HttpClient }, { type: CitadelServerSentNotificationsService }, { type: CitadelConfigurationService }, { type: CitadelStringInterpolationService }] });

class CitadelValidators {
    static minDate(date) {
        return (control) => {
            date.setHours(0, 0, 0, 0);
            const value = new Date(control.value);
            value.setHours(0, 0, 0, 0);
            if (value >= date) {
                return undefined;
            }
            else {
                return { minDate: { min: date, actual: value } };
            }
        };
    }
    static maxDate(date) {
        return (control) => {
            date.setHours(0, 0, 0, 0);
            const value = new Date(control.value);
            value.setHours(0, 0, 0, 0);
            if (value <= date) {
                return undefined;
            }
            else {
                return { maxDate: { max: date, actual: value } };
            }
        };
    }
    static minDateTime(date) {
        return (control) => {
            const value = new Date(control.value);
            if (value >= date) {
                return undefined;
            }
            else {
                return { minDateTime: { min: date, actual: value } };
            }
        };
    }
    static maxDateTime(date) {
        return (control) => {
            const value = new Date(control.value);
            if (value <= date) {
                return undefined;
            }
            else {
                return { maxDateTime: { max: date, actual: value } };
            }
        };
    }
    static beforeToday() {
        return (control) => {
            const date = new Date();
            date.setHours(0, 0, 0, 0);
            date.setDate(date.getDate() - 1);
            const value = new Date(control.value);
            value.setHours(0, 0, 0, 0);
            if (value <= date) {
                return undefined;
            }
            else {
                return { maxDate: { max: date, actual: value } };
            }
        };
    }
    static beforeOrOnToday() {
        return (control) => {
            const date = new Date();
            date.setHours(0, 0, 0, 0);
            const value = new Date(control.value);
            value.setHours(0, 0, 0, 0);
            if (value <= date) {
                return undefined;
            }
            else {
                return { maxDate: { max: date, actual: value } };
            }
        };
    }
    static toDateAfterFromDate(fromDateName, toDateName) {
        return (control) => {
            const group = control instanceof FormGroup ? control : undefined;
            const fromDateInput = group.controls[fromDateName]?.value;
            const fromDate = fromDateInput ? new Date(fromDateInput) : undefined;
            const toDateInput = group.controls[toDateName]?.value;
            const toDate = toDateInput ? new Date(toDateInput) : undefined;
            if (!fromDate || !toDate || fromDate.setHours(0, 0, 0, 0) < toDate.setHours(0, 0, 0, 0)) {
                return undefined;
            }
            else {
                return { toDateAfterFromDate: { from: fromDate, to: toDate } };
            }
        };
    }
}

class CitadelPair {
}

class CitadelMenuItemCrosslinkService {
    constructor(web) {
        this.web = web;
        this.crossLinkCache = [];
        this.crossLink_subject = new BehaviorSubject([]);
        this.crossLink_observable = this.crossLink_subject.asObservable();
        this.subCrossLink = this.crossLink_observable.subscribe(() => { });
    }
    ngOnDestroy() {
        if (this.sub !== undefined) {
            this.sub.unsubscribe();
        }
        if (this.subCrossLink) {
            this.subCrossLink.unsubscribe();
        }
    }
    getCrossLinkItems(authMenuItemID) {
        return this.web.get('Citadel.Menu/menuItemCrossLink', authMenuItemID);
    }
    menuItemCrossLinkbyApplication(authApplicationID, reload = false) {
        if (this.crossLinkCache.length === 0 || reload) {
            this.sub = this.web.get('Citadel.Menu/menuItemCrossLinkbyApplication', authApplicationID).subscribe(results => {
                this.crossLinkCache = results;
                this.crossLink_subject.next(results);
            });
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelMenuItemCrosslinkService, deps: [{ token: CitadelWebService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelMenuItemCrosslinkService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelMenuItemCrosslinkService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: CitadelWebService }] });

class LookupEntries {
    entryByID(lid) {
        return this.byID[lid];
    }
    entriesByLabel(label) {
        return this.byLabel[label.toUpperCase().normalize()];
    }
    constructor(entries) {
        this.entries = entries;
        this.byID = {};
        this.byLabel = {};
        this.sourceEntries = entries;
        for (const entry of entries) {
            this.byID[entry.lid] = entry;
            this.assignLabel(entry);
            this.byLabel[(entry.label || entry.description).toUpperCase().normalize()] = entry;
        }
    }
    assignLabel(entry) {
        if (entry.description && !entry.label) {
            entry.label = entry.description;
            delete entry.description;
        }
        if (!entry.label) {
            if (!this.longestField) {
                this.longestField = this.calculateLongestField();
            }
            if (this.longestField) {
                entry.label = entry[this.longestField];
            }
        }
    }
    calculateLongestField() {
        let maxLength = 0;
        let longestField = '';
        for (const obj of this.sourceEntries) {
            for (const key in obj) {
                if (typeof obj[key] === 'string') {
                    const len = obj[key].length;
                    if (len > maxLength) {
                        maxLength = len;
                        longestField = key;
                    }
                }
            }
        }
        return longestField;
    }
}

class CitadelLookupService {
    constructor(web) {
        this.web = web;
        this.scopes = {};
    }
    get(scope, name) {
        const scopeN = this.normalizeString(scope);
        const nameN = this.normalizeString(name);
        if (!this.scopes[scopeN]) {
            this.scopes[scopeN] = {};
        }
        if (!this.scopes[scopeN][nameN]) {
            const subject = this.createObservable(scopeN, nameN);
            this.web.get('Citadel.Lookups', `${scope}/${name}`).subscribe(result => {
                const entries = new LookupEntries(result);
                subject.next(entries);
            });
        }
        return this.scopes[scopeN][nameN];
    }
    getList(scope, names) {
        const scopeNormalized = this.normalizeString(scope);
        if (!this.scopes[scopeNormalized]) {
            this.scopes[scopeNormalized] = {};
        }
        const namesNormalized = names.map(name => this.normalizeString(name));
        const namesToFetch = namesNormalized.filter(name => !this.scopes[scopeNormalized][name]);
        if (namesToFetch.length > 0) {
            const subjects = {};
            for (const name of namesToFetch) {
                const subject = this.createObservable(scopeNormalized, name);
                subjects[name] = subject;
            }
            this.web.post(`Citadel.Lookups/${scopeNormalized}`, namesToFetch).subscribe(result => {
                for (const name of namesToFetch) {
                    const entries = new LookupEntries(result[name]);
                    subjects[name].next(entries);
                }
            });
        }
        return namesNormalized.map(name => this.scopes[scopeNormalized][name]);
    }
    getDictionary(scope, names) {
        return combineLatest(this.getList(scope, names)).pipe(map$1(lookups => names.reduce((result, current, index) => {
            result[current] = lookups[index];
            return result;
        }, {})));
    }
    normalizeString(input) {
        return input.toUpperCase().normalize();
    }
    createObservable(scopeN, nameN) {
        const subject = new ReplaySubject(1);
        const obs = subject.asObservable();
        this.scopes[scopeN][nameN] = obs;
        return subject;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelLookupService, deps: [{ token: CitadelWebService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelLookupService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelLookupService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: CitadelWebService }] });

const CitadelChartColors = [
    '#ed5765', // red
    '#3eba95', // green
    '#6f42c1', // purple
    '#adb5bd', // gray 
    '#e27525', // orange
    '#558cdc', // blue
    '#dc74ed', // pink 
    '#8155c7', // lighter purple    
];
const CitadelPieChartConfig = {
    aspectRatio: 2.5,
    cutout: '90%',
    borderRadius: 15,
    offset: 15,
    responsive: true,
    cutoutPercentage: 90,
    layout: {
        padding: {
            top: 150,
            bottom: 150
        }
    },
    plugins: {
        legend: {
            display: false
        },
        outlabels: {
            backgroundColor: "#fff", // Background color of Label
            borderColor: "#fff", // Border color of Label
            borderRadius: 4, // Border radius of Label
            color: 'black', // Font color
            display: true,
            font: {
                minSize: 14,
                size: 14,
                weight: 600
            },
            lineColor: 'transparent',
            lineWidth: 1, // Thickness of line between chart arc and Label
            padding: {
                top: 5,
                bottom: 5,
                left: 10,
                right: 10
            },
            stretch: 100, // The length between chart arc and Label
            text: "%p",
            textAlign: "center"
        }
    }
};

var ScreenSize;
(function (ScreenSize) {
    ScreenSize[ScreenSize["xs"] = 0] = "xs";
    ScreenSize[ScreenSize["sm"] = 1] = "sm";
    ScreenSize[ScreenSize["md"] = 2] = "md";
    ScreenSize[ScreenSize["lg"] = 3] = "lg";
    ScreenSize[ScreenSize["xl"] = 4] = "xl";
})(ScreenSize || (ScreenSize = {}));

class CitadelScreenService {
    constructor(breakpoints) {
        this.breakpoints = breakpoints;
        this.sizeSubject = new ReplaySubject(1);
        this.deviceSubject = new ReplaySubject(1);
        this.sizeObs = this.sizeSubject.pipe(distinctUntilChanged$1());
        this.deviceObs = this.deviceSubject.pipe(distinctUntilChanged$1());
        this.breakpoints
            .observe([
            Breakpoints.XSmall,
            Breakpoints.Small,
            Breakpoints.Medium,
            Breakpoints.Large,
            Breakpoints.XLarge,
        ]).pipe(distinctUntilChanged$1(), takeUntilDestroyed())
            .subscribe((value) => {
            if (value.breakpoints[Breakpoints.XSmall]) {
                this.setSize(ScreenSize.xs);
                this.setDeviceType('mobile');
            }
            else if (value.breakpoints[Breakpoints.Small]) {
                this.setSize(ScreenSize.sm);
                this.setDeviceType('tablet');
            }
            else if (value.breakpoints[Breakpoints.Medium]) {
                this.setSize(ScreenSize.md);
                this.setDeviceType('desktop');
            }
            else if (value.breakpoints[Breakpoints.Large]) {
                this.setSize(ScreenSize.lg);
                this.setDeviceType('desktop');
            }
            else {
                this.setSize(ScreenSize.xl);
                this.setDeviceType('desktop');
            }
        });
    }
    screenSize() {
        return this.sizeObs;
    }
    deviceScreenType() {
        return this.deviceObs;
    }
    setDeviceType(type) {
        this.deviceSubject.next(type);
    }
    setSize(size) {
        this.sizeSubject.next(size);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelScreenService, deps: [{ token: i1$3.BreakpointObserver }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelScreenService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelScreenService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: i1$3.BreakpointObserver }] });

class CitadelPauseService {
    registerPauser(name, pauser) {
        this.fields[name] = pauser;
    }
    unregisterPauser(name) {
        delete this.fields[name];
    }
    get(name) {
        return this.fields[name];
    }
    constructor() {
        this.fields = {};
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelPauseService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelPauseService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelPauseService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [] });

// global-error-handler.ts
class CitadelGlobalErrorHandler {
    constructor(errorLoggingService) {
        this.errorLoggingService = errorLoggingService;
        this.setupGlobalErrorHandlers();
    }
    handleError(error) {
        // Log the error using the ErrorLoggingService
        this.errorLoggingService.logError(error);
        console.error('ERROR:', error);
    }
    setupGlobalErrorHandlers() {
        // Catch synchronous errors
        window.onerror = (message, source, lineno, colno, error) => {
            this.errorLoggingService.logError(error || new Error(message));
            return true; // Prevents the default browser error handling
        };
        // Catch unhandled promise rejections
        window.onunhandledrejection = (event) => {
            this.errorLoggingService.logError(event.reason);
            return true; // Prevents the default browser error handling
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelGlobalErrorHandler, deps: [{ token: CitadelErrorLoggingService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelGlobalErrorHandler, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelGlobalErrorHandler, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: CitadelErrorLoggingService }] });

const CitadelNavLoggingGuard = (_route, _state) => {
    const errorLogger = inject(CitadelErrorLoggingService);
    errorLogger.logError('navigation', window.location.href);
    return errorLogger.sendMessagesToWebService().pipe(map$1(() => true));
};

class CitadelCoreModule {
    constructor(coreModule) {
        if (coreModule) {
            throw new Error('CitadelCoreModule is already loaded. Import it in the AppModule only');
        }
        // this.routerNavigate = router.navigate;
        // Router.prototype.navigate = (commands: any[], extras?: NavigationExtras) => {
        //     const newCommands = commands.length !== 1 ? commands : [];
        //     const newExtras = extras || {};
        //     if (commands.length === 1) {
        //         const command: string = commands[0].toString();
        //         const posQ = command.indexOf('?');
        //         if (posQ === -1) {
        //             newCommands.push(command);
        //         } else {
        //             newCommands.push(command.substr(0, posQ));
        //             const paramStr = command.substr(posQ + 1);
        //             const qparams = paramStr.split('&').reduce((prev, current) => {
        //                 const pair = current.split('=');
        //                 const param = {};
        //                 param[pair[0]] = decodeURI(pair[1]);
        //                 return { ...prev, ...param }
        //             }, {});
        //             newExtras.queryParams = qparams;
        //         }
        //     }
        //     return this.routerNavigate.call(router, newCommands, newExtras);
        // };
    }
    static forRoot(options) {
        return {
            ngModule: CitadelCoreModule,
            providers: [
                { provide: CITADEL_DIAGNOSTIC_OPTIONS, useValue: options }
            ]
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelCoreModule, deps: [{ token: CitadelCoreModule, optional: true, skipSelf: true }], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CitadelCoreModule, imports: [CommonModule,
            HttpClientModule,
            CitadelStylesModule, i1$1.RouterModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelCoreModule, providers: [
            { provide: HTTP_INTERCEPTORS, useClass: CitadelJsonInterceptor, multi: true },
            { provide: HTTP_INTERCEPTORS, useClass: CitadelAuthInterceptor, multi: true },
            { provide: HTTP_INTERCEPTORS, useClass: CitadelDeviceInterceptor, multi: true },
            { provide: HTTP_INTERCEPTORS, useClass: CitadelLoggerInterceptor, multi: true }, // Conditional
        ], imports: [CommonModule,
            HttpClientModule,
            CitadelStylesModule,
            RouterModule.forChild([])] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelCoreModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [
                        CommonModule,
                        HttpClientModule,
                        CitadelStylesModule,
                        RouterModule.forChild([]),
                    ],
                    providers: [
                        { provide: HTTP_INTERCEPTORS, useClass: CitadelJsonInterceptor, multi: true },
                        { provide: HTTP_INTERCEPTORS, useClass: CitadelAuthInterceptor, multi: true },
                        { provide: HTTP_INTERCEPTORS, useClass: CitadelDeviceInterceptor, multi: true },
                        { provide: HTTP_INTERCEPTORS, useClass: CitadelLoggerInterceptor, multi: true }, // Conditional
                    ],
                    exports: []
                }]
        }], ctorParameters: () => [{ type: CitadelCoreModule, decorators: [{
                    type: Optional
                }, {
                    type: SkipSelf
                }] }] });

/*
 * Public API Surface of citadel-core
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AuthUser, CITADEL_DIAGNOSTIC_OPTIONS, CitadelAuthService, CitadelAuthenticatedUserGuard, CitadelBlankRecentClientsService, CitadelCalculationsService, CitadelChartColors, CitadelClientInfoLoaderService, CitadelClientService, CitadelConfigurationService, CitadelCoreModule, CitadelDataCache, CitadelDataCacheService, CitadelDateService, CitadelDeviceInterceptor, CitadelDiagnosticsService, CitadelErrorLoggingService, CitadelFormChangesService, CitadelGlobalErrorHandler, CitadelLoaderService, CitadelLoggerService, CitadelLookupService, CitadelMaintenanceService, CitadelMenuItemCrosslinkService, CitadelMenuItemRules, CitadelMenuService, CitadelNavLoggingGuard, CitadelNavigationService, CitadelNotificationService, CitadelPair, CitadelPauseService, CitadelPieChartConfig, CitadelRecentClientsService, CitadelScreenService, CitadelSearchService, CitadelServerSentNotificationsService, CitadelSilentImpersonationService, CitadelStorageService, CitadelStringInterpolationService, CitadelTextService, CitadelUnsavedFormChangesGuard, CitadelUserInfoLoaderService, CitadelUserService, CitadelValidators, CitadelWebService, ClientSharingApprover, Deprecated, Log, LookupEntries, RouteFixedTargets, SafeToastrService, ScreenSize, Timeout, lkpAuthRoleType, lkpAuthenticationType, lkpClientBlockStatus, lkpGender, lkpPartyType, lkpPermissionType, paymentsDue, redirectBlacklist };
